<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-expand-x-transition>
        <v-card class="d-print-none" v-show="TypeCreateProject == '1'">
          <v-list>
            <v-list-item class="d-flex justify-center">
              <span style="font-weight: bold;font-size: 24px;color: #42b983">เสนอแผนขออนุมัติงบประมาณประจำปี</span>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12"
                    class="d-flex justify-center"
                >
                  <!-- <v-radio-group row v-model="YearSel" @change="ChooseYearFiscal"> -->
                  <v-radio-group row v-model="YearSel" @change="selProjFiscalYear">
                    <v-radio v-for="(yearMenu, idx) in FiscalYearMenuData" :key="idx"
                              :label="'แผนประจำปี ' + yearMenu.yearth" :value="yearMenu.year">
                      <template v-slot:label>
                        <div>
                      <span>
                        แผนประจำปี {{ yearMenu.yearth }}
                      </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark v-if="YearSel == yearMenu.year">
                            {{
                              projectPlanAllData.filter(projI => projI.Project_type == TypeProject && projI.FiscalYear == yearMenu.year).length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1"><span>ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</span>
                </v-list-item-title>
                <v-list-item class="justify-center">
                  <v-radio-group v-model="chooseTypePlan" row @change="ClearData">
                    <v-radio value="1" class="font-weight-bold" label="ข้อมูลแผนตามสิทธิ์หน่วยงาน"></v-radio>
                    <v-radio value="0" class="font-weight-bold" label="ข้อมูลแผนทั้งหมด"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-row
                      justify="center">
                    <v-col
                        cols="12"
                        md="8">
                      <template v-if="chooseTypePlan == '0'">
                        <v-autocomplete
                            :items="Project_plan.filter(item => item.Project_type == TypeProject && item.Approve == '1')"
                            item-text="full_Text"
                            item-value="Project_code"
                            v-model="ProjectPlan"
                            label="แผนขออนุมัติงบประมาณ"
                            @click:clear="clearProjectPlan"
                            clearable
                            @change="GetPlanToForm"
                            outlined
                        >
                          <template v-slot:selection="{item}">
                          <span>
                            {{ (item.full_Text.replaceAll("[^a-zA-Z]+", "")) }}
                          <v-chip
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-chip
                              v-if="item.IsDataComplete == '0'"
                              color="#E53935"
                              style="transform: scale(0.8);color: white"
                          >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                                 </span>
                          </template>
                          <template v-slot:item="{item}">
                          <span>
                            {{ (item.full_Text.replaceAll("[^a-zA-Z]+", "")) }}
                          <v-chip
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-chip
                              v-if="item.IsDataComplete == '0'"
                              color="#E53935"
                              style="transform: scale(0.8);color: white"
                          >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                                 </span>
                          </template>
                        </v-autocomplete>
                      </template>
                      <template v-else>
                        <v-autocomplete
                            :items="Project_plan2.filter(item => item.Project_type == TypeProject && item.Approve == '1')"
                            item-text="full_Text"
                            item-value="Project_code"
                            v-model="ProjectPlan"
                            label="แผนขออนุมัติงบประมาณ"
                            @click:clear="clearProjectPlan"
                            clearable
                            @change="GetPlanToForm"
                            outlined
                        >
                          <template v-slot:selection="{item}">
                          <span>
                            {{ (item.full_Text.replaceAll("[^a-zA-Z]+", "")) }}
                          <v-chip
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-chip
                              v-if="item.IsDataComplete == '0'"
                              color="#E53935"
                              style="transform: scale(0.8);color: white"
                          >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                                 </span>
                          </template>
                          <template v-slot:item="{item}">
                          <span>
                            {{ (item.full_Text.replaceAll("[^a-zA-Z]+", "")) }}
                          <v-chip
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-chip
                              v-if="item.IsDataComplete == '0'"
                              color="#E53935"
                              style="transform: scale(0.8);color: white"
                          >
                            <span style="color: white">ข้อมูลไม่สมบูรณ์</span>
                          </v-chip>
                                 </span>
                          </template>
                        </v-autocomplete>
                      </template>
                    </v-col>
                  </v-row>
                </v-list-item>
                <!--              <v-list-item>
                                <v-row justify="space-around">
                                  <span>วันที่เริ่มต้นโครงการ</span>
                                  <span>วันที่สิ้นสุดโครงการ</span>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      class="d-flex justify-center"
                                      cols="12"
                                      md="6"
                                  >
                                    <v-date-picker
                                        v-model="DateStart"
                                        :landscape="landscape"
                                        :reactive="reactive"
                                        :full-width="fullWidth"
                                        :show-current="showCurrent"
                                        :type="month ? 'month' : 'date'"
                                        :multiple="multiple"
                                        :readonly="readonly"
                                        :disabled="disabled"
                                        locale="th"
                                        :events="enableEvents ? functionEvents : null"
                                        :color="DateStart == '' ? 'red' : 'primary'"
                                        style="border: 1px solid black;border-radius: 5px"
                                    ></v-date-picker>
                                  </v-col>
                                  <v-col
                                      class="d-flex justify-center"
                                      cols="12"
                                      md="6">
                                    <v-date-picker
                                        v-model="DateEnd"
                                        :landscape="landscape"
                                        :reactive="reactive"
                                        :full-width="fullWidth"
                                        :show-current="showCurrent"
                                        :type="month ? 'month' : 'date'"
                                        :multiple="multiple"
                                        :readonly="readonly"
                                        :disabled="disabled"
                                        locale="th"
                                        :events="enableEvents ? functionEvents : null"
                                        :color="DateEnd == '' ? 'red' : 'primary'"
                                        style="border: 1px solid black;border-radius: 5px"
                                    ></v-date-picker>
                                  </v-col>
                                </v-row>
                              </v-list-item>-->
                <v-row>
                  <v-col
                      cols="12"
                      md="6">
                    <v-card>
                      <v-card-subtitle>
                        <span style="font-size: 20px;color: black;font-weight: bold">ข้อมูลแผน</span>
                        <v-spacer></v-spacer>
                        <span style="font-size: 20px;color: green;font-weight: bold" v-if="DateForPlan.length > 0">ช่วงระยะเวลาเสนอแผน ประจำปี {{
                            parseInt(DateForPlan[DateForPlan.length - 1].year) + 543
                          }} : {{
                            DateForPlan[DateForPlan.length - 1].date_start | dateToThai
                          }} - {{ DateForPlan[DateForPlan.length - 1].date_end | dateToThai }}</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-list-item style="margin-top: 20px">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="8"
                            >
                              <v-autocomplete
                                  v-model="DepSelect"
                                  label="หน่วยงาน"
                                  :items="depart"
                                  item-text="dep_name"
                                  item-value="dep_id"
                                  hint="หน่วยงาน (ห้ามว่าง)"
                                  :error-messages="DepSelect == null ? 'หน่วยงาน (ห้ามว่าง)' : ''"
                                  persistent-hint
                                  :error="DepSelect == null"
                                  clearable
                              >

                              </v-autocomplete>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                            >
                              <v-autocomplete
                                  v-model="FiscalYear"
                                  label="แผนปี"
                                  :items="FiscalYearData"
                                  item-text="yearth"
                                  item-value="year"
                                  :error-messages="FiscalYear == '' ? 'แผนปี (ห้ามว่าง)' : ''"
                                  persistent-hint
                                  :error="FiscalYear == ''"
                                  @change="getCourseType"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != '' && TypeProject == '2'">
                          <span style="font-weight: bold">ประเภทการทำรายการ</span>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != '' && TypeProject == '2'">
                          <v-radio-group row
                                         v-model="IsProcess"
                                         :error="IsProcess == null"
                                         :error-messages="IsProcess == null ? 'ประเภทการทำรายการ' : ''"
                                         persistent-hint
                                         :rules="[rules.required]"
                                         required
                          >
                            <v-radio value="2" class="font-weight-bold" label="เดินทางไปราชการ (ในวิชาชีพ)"
                                     color="green"></v-radio>
                            <v-radio value="1" class="font-weight-bold" label="เดินทางไปราชการ (นอกวิชาชีพ)"
                                     color="yellow"></v-radio>
                            <v-radio value="3" class="font-weight-bold" label="เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)"
                                     color="red"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != ''">
                          <span style="font-weight: bold">หมวดโครงการ</span>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != ''">
                          <v-radio-group row
                                         v-model="Project_category"
                                         :error="Project_category == null"
                                         :error-messages="Project_category == null ? 'หมวดโครงการ (ห้ามว่าง)' : ''"
                                         persistent-hint
                                         :rules="[rules.required]"
                                         required
                                         @change="ChooseCompetency"
                          >
                            <v-radio value="1" class="font-weight-bold" label="พัฒนาบุคลากร"></v-radio>
                            <v-radio value="2" class="font-weight-bold" label="โครงการอื่นๆ"></v-radio>
                            <v-radio value="3" class="font-weight-bold" label="บริการวิชาการ"></v-radio>
                            <v-radio value="4" class="font-weight-bold" label="วิจัย"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != ''">
                          <span style="font-weight: bold">ประเภทแผน</span>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != ''">
                          <v-radio-group row
                                         v-model="isPlan"
                                         :error="isPlan == null"
                                         :error-messages="isPlan == null ? 'ประเภทแผน (ห้ามว่าง)' : ''"
                                         persistent-hint
                                         :rules="[rules.required]"
                                         required
                                         @change="getCourseType"
                          >
                            <v-radio value="1" class="font-weight-bold" label="งานในแผน"
                                     :disabled="isPlanCordi"></v-radio>
                            <v-radio value="0" class="font-weight-bold" label="งานนอกแผน"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != ''">
                          <span style="font-weight: bold">ระยะเวลาที่คาดว่าจะจัด</span>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="FiscalYear != ''">
                          <v-radio-group row
                                         v-model="episode"
                                         :error="episode == null"
                                         :error-messages="episode == null ? 'ระยะเวลาที่คาดว่าจะจัดแผน (ห้ามว่าง)' : ''"
                                         persistent-hint
                                         :rules="[rules.required]"
                                         required
                                         @change="changeDate"
                          >
                            <v-radio class="font-weight-bold" value="1"
                                     :label="'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)"></v-radio>
                            <v-radio class="font-weight-bold" value="2"
                                     :label="'ม.ค. ' + (parseInt(FiscalYear) + 543)  + '- มี.ค. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                            <v-radio class="font-weight-bold" value="3"
                                     :label="'เม.ย. ' + (parseInt(FiscalYear) + 543)  + '- มิ.ย. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                            <v-radio class="font-weight-bold" value="4"
                                     :label="'ก.ค. ' + (parseInt(FiscalYear) + 543)  + '- ก.ย. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                            <v-radio class="font-weight-bold" value="9"
                                     :label="'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <p style="color: blue;font-weight: bold" v-if="episode == '9'">
                          ***** สามารถระบุรายละเอียดระยะเวลาที่จัดเพิ่มเติมได้ที่ช่อง รายละเอียดประกอบ (เพิ่มเติม)
                          ได้ที่ช่องด้านล่างเพื่อเป็นข้อมูลประกอบการพิจารณา *****
                        </p>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <v-text-field v-model="Project_code" label="รหัสแผน"
                                              hide-details="auto" disabled></v-text-field>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <v-text-field v-model="Project_name" label="ชื่องาน / กิจกรรม"
                                              :rules="[rules.required]"
                                              required
                                              hide-details="auto"
                                              :error-messages="Project_name == '' ? 'ชื่องาน / กิจกรรม (ห้ามว่าง)' : ''"
                                              :error="Project_name == ''"
                                              persistent-hint></v-text-field>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <v-select
                                    :error="Project_group == ''"
                                    v-model="Project_group"
                                    :items="TypeProject == '1' ? projectGroup.filter(item => item.Type == '1') : projectGroup.filter(item => item.Type == '2')"
                                    item-value="Project_group"
                                    item-text="Project_group_des"
                                    label="ประเภทแผน"
                                    :error-messages="Project_group == '' ? 'ประเภทแผน (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    :rules="[rules.required]"
                                    required
                                    @change="SelProjectGroup"
                                >
                                </v-select>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <!--                      <v-autocomplete
                                                          :items="courseData"
                                                          item-text="Course_name"
                                                          item-value="Course_code"
                                                          v-model="Course_code"
                                                          label="หลักสูตร"
                                                          @change="getCourseType"
                                                          @click:clear="CheckCourseClear"
                                                          :error-messages="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == '0000000') ? 'หลักสูตร (ห้ามว่าง)' : ''"
                                                          :error="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == '0000000')"
                                                          persistent-hint
                                                          clearable
                                                      ></v-autocomplete>-->
                                <v-autocomplete
                                    :items="courseData"
                                    item-text="Course_name"
                                    item-value="Course_code"
                                    v-model="Course_code"
                                    label="หลักสูตร"
                                    @change="getCourseType"
                                    @click:clear="CheckCourseClear"
                                    persistent-hint
                                    clearable
                                ></v-autocomplete>
                              </div>
                            </v-col>
                            <template v-if="Course_code != null">
                              <v-col
                                  cols="12"
                                  md="6"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="course_group"
                                      label="สาขาประเภทหลักสูตร"
                                      required
                                      disabled
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="6"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      readonly
                                      :items="period"
                                      item-text="name"
                                      item-value="id"
                                      v-model="Period_code"
                                      label="ระยะเวลา"
                                      required
                                      disabled
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                            </template>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-text-field type="number"
                                              :error="CalHourse == ''"
                                              v-model="CalHourse"
                                              label="จำนวน ช.ม"
                                              hide-details="auto"
                                              :rules="[rules.required]"
                                              required
                                              :error-messages="CalHourse == '' ? 'จำนวน ช.ม (ห้ามว่าง)' : ''"
                                              persistent-hint></v-text-field>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-text-field type="number"
                                              :error="CalCredit == ''"
                                              v-model="CalCredit"
                                              label="จำนวน เครดิต"
                                              hide-details="auto"
                                              :error-messages="CalCredit == '' ? 'จำนวน เครดิต (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                              persistent-hint></v-text-field>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-select
                                    :items="PLACESelete"
                                    item-value="id"
                                    item-text="detail"
                                    :error="PLACE == ''"
                                    v-model="PLACE"
                                    label="งาน / กิจกรรม ถูกจัดขึ้น"
                                    :error-messages="PLACE == '' ? 'งาน / กิจกรรม ถูกจัดขึ้น (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    required
                                    :rules="[rules.required]"
                                    @change="CheckPlace"
                                >
                                </v-select>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline" v-if="PLACE == '2'">
                                <v-autocomplete
                                    :error="Province_id == ''"
                                    v-model="Province_id"
                                    :items="provinces_Data"
                                    item-text="name_th"
                                    item-value="code"
                                    label="จังหวัด"
                                    :error-messages="Province_id == '' ? 'จังหวัด (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    required
                                    :rules="[rules.required]"></v-autocomplete>
                              </div>
                              <div class="d-inline" v-if="PLACE == '3'">
                                <v-autocomplete
                                    :error="Country_id == ''"
                                    v-model="Country_id"
                                    :items="countryData"
                                    item-text="ct_nameTHA"
                                    item-value="ct_code"
                                    label="ประเทศ"
                                    :error-messages="Country_id == '' ? 'ประเทศ (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    required
                                    :rules="[rules.required]"></v-autocomplete>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-text-field type="number"
                                              :error="BudgetRequest == ''"
                                              v-model="BudgetRequest"
                                              label="งบประมาณที่ขอ"
                                              hide-details="auto"
                                              :rules="[rules.required]"
                                              required
                                              :error-messages="BudgetRequest == '' ? 'งบประมาณที่ขอ (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                              persistent-hint></v-text-field>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-select
                                    :error="WorkBy == ''"
                                    v-model="WorkBy"
                                    label="จัดโดย"
                                    :items="WorkByData"
                                    item-value="id"
                                    item-text="detail"
                                    :error-messages="WorkBy == '' ? 'จัดโดย (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    required
                                    :rules="[rules.required]"></v-select>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-text-field
                                    :error="WorkByName == ''"
                                    v-model="WorkByName"
                                    label="ชื่อผู้จัด"
                                    hide-details="auto"
                                    :error-messages="WorkByName == '' ? 'ชื่อผู้จัด (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    required
                                    :rules="[rules.required]"></v-text-field>
                              </div>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-text-field
                                    v-model="Location"
                                    label="สถานที่จัด"
                                    hide-details="auto"></v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <div class="d-inline">
                                <v-text-field
                                    :error="WorkByPhone == ''"
                                    v-model="WorkByPhone"
                                    label="เบอร์โทรติดต่อผู้กรอกข้อมูล"
                                    hide-details="auto"
                                    :error-messages="WorkByPhone == '' ? 'เบอร์โทรติดต่อผู้กรอกข้อมูล (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    required
                                    :rules="[rules.required]"></v-text-field>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <v-textarea
                                    v-model="TargetGroup"
                                    outlined
                                    name=""
                                    label="กลุ่มเป้าหมาย"
                                    value=""
                                    persistent-hint
                                    :error="TargetGroup == '' || TargetGroup == null"
                                    :error-messages="(TargetGroup == '' || TargetGroup == null) ? 'กลุ่มเป้าหมาย (ห้ามว่าง)' : ''"
                                    required
                                ></v-textarea>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <v-textarea
                                    v-model="Objective"
                                    outlined
                                    name=""
                                    label="วัตถุประสงค์"
                                    value=""
                                    persistent-hint
                                    :error="Objective == '' || Objective == null"
                                    :error-messages="(Objective == '' || Objective == null) ? 'วัตถุประสงค์ (ห้ามว่าง)' : ''"
                                    required
                                ></v-textarea>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                            >
                              <div class="d-inline">
                                <v-textarea
                                    v-model="Remarks"
                                    outlined
                                    name=""
                                    label="รายละเอียดประกอบ (เพิ่มเติม ถ้ามี)"
                                    value=""
                                    persistent-hint
                                ></v-textarea>
                              </div>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <v-file-input
                              v-model="files"
                              color="deep-purple accent-4"
                              counter
                              label="แนบไฟล์เอกสารประกอบ"
                              multiple
                              placeholder="เลือกไฟล์"
                              prepend-icon="mdi-paperclip"
                              outlined
                              :show-size="1000"
                              @change="FileSelect"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip
                                  v-if="index < 5"
                                  color="deep-purple accent-4"
                                  dark
                                  label
                                  small
                              >
                                {{ text }}
                              </v-chip>

                              <span
                                  v-else-if="index === 5"
                                  class="overline grey--text text--darken-3 mx-2"
                              >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                            </template>
                          </v-file-input>
                        </v-list-item>
                        <v-list-item>
                          <p style="font-weight: bold;color: #ff6d81;text-align: right;width: 100%">**สนับสนุนไฟล์
                            PDF เท่านั้น</p>
                        </v-list-item>
                        <v-list-item>
                          <v-alert
                              v-if="alert"
                              prominent
                              type="error"
                          >
                            <v-row align="center" v-for="item in txtAlert" :key="item.id">
                              <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                            </v-row>
                          </v-alert>
                        </v-list-item>
                        <v-list-item v-if="FileProject.length > 0">
                          <template>
                            <v-row>
                              <v-col cols="12">
                                <v-card>
                                  <v-card-title>
                                    ไฟล์เอกสารประกอบ
                                  </v-card-title>
                                  <v-container fluid>
                                    <v-row>
                                      <v-col
                                          v-for="(file_i, index) in FileProject"
                                          :key="index"
                                          class="d-flex child-flex"
                                          cols="12"
                                          md="4"
                                      >
                                        <v-card flat tile class="d-flex">
                                          <v-img
                                              v-if="file_i.type == 'image'"
                                              :src="file_i.src"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1"
                                              class="grey lighten-2"
                                          >
                                            <template v-slot:placeholder>
                                              <v-row
                                                  class="fill-height ma-0"
                                                  align="center"
                                                  justify="center"
                                              >
                                                <v-progress-circular
                                                    indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                              </v-row>
                                            </template>
                                          </v-img>
                                          <v-img
                                              v-if="file_i.type == 'pdf'"
                                              src="../../assets/Image/pdf.png"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1"
                                              class="grey lighten-2"
                                          >
                                            <template v-slot:placeholder>
                                              <v-row
                                                  class="fill-height ma-0"
                                                  align="center"
                                                  justify="center"
                                              >
                                                <v-progress-circular
                                                    indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                              </v-row>
                                            </template>
                                          </v-img>
                                          <v-card-actions>
                                            <v-btn text
                                                   @click="ShowData(file_i.src)">
                                                                                          <span style="color: indigo">
                                                                                              เรียกดู
                                                                                          </span>
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card>
                              </v-col>
                            </v-row>
                          </template>
                        </v-list-item>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6">
                    <v-card>
                      <v-card-subtitle>
                        <span style="font-size: 20px;color: black;font-weight: bold">Strategic Objective( วัตถุประสงค์เชิงกลยุทธ์ )</span>
                      </v-card-subtitle>
                      <v-card-text>
                        <v-list>
                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="headline mb-1">
                                <span>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                              </v-list-item-title>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                      md="12"
                                  >
                                    <v-row class="d-flex justify-center">
                                      <v-col
                                          cols="12"
                                          md="12">
                                        <v-responsive>
                                          <v-spacer></v-spacer>
                                          <v-text-field label="ค้นหา สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์"
                                                        v-model="searchCompe"></v-text-field>
                                        </v-responsive>
                                        <v-responsive>
                                          <v-treeview v-model="selection" selectable
                                                      :activatable="true"
                                                      :items="CompetencyData"
                                                      :search="searchCompe"
                                                      @input="ChooseCompetency"
                                          >
                                            <template v-slot:prepend="{ item, open }">
                                              <v-icon v-if="!item.file"
                                                      color="blue lighten-2">
                                                {{
                                                  open ? 'mdi-folder-open' :
                                                      'mdi-folder'
                                                }}
                                              </v-icon>
                                              <v-icon v-else>
                                                {{ files[item.file] }}
                                              </v-icon>
                                            </template>
                                            <template v-slot:label="{ item, active }">
                                              <div v-if="isMobile" style="cursor: pointer"
                                                   @click="ShowDetail(item)">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                                <span style="font-size: 12px;color: blue;font-weight: bold"
                                                      v-else>
                                                    {{ item.name }}
                                                </span>
                                              </div>
                                              <div v-else style="cursor: pointer"
                                                   @click="ShowDetail(item)">
                                                <span
                                                    :style="item.checkCordi ? {color:'red', fontWeight: 'bold'} : {color:'black'}"
                                                    v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                                <span style="font-size: 12px;color: blue;font-weight: bold"
                                                      v-else>
                                                    {{ item.name }}
                                                </span>
                                                <!--                                                <span style="color: #364eff;font-weight: bold"-->
                                                <!--                                                      v-else>-->
                                                <!--                                                    {{ item.name }}-->
                                                <!--                                                </span>-->
                                              </div>
                                            </template>
                                          </v-treeview>
                                        </v-responsive>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="d-flex justify-center">
              <v-row>
                <v-col
                    class="d-flex justify-center"
                    md="6"
                    cols="12">
                  <v-btn
                      color="primary"
                      @click="insertProject('0')"
                      :disabled="btnDisable"
                      dark
                      class="pa-10"
                  >
                    <span style="font-weight: bold;font-size: 20px">บันทึกแผน</span>
                  </v-btn>
                </v-col>
                <v-col
                    class="d-flex justify-center"
                    md="6"
                    cols="12">
                  <v-btn
                      color="primary"
                      @click="insertProject('1')"
                      :disabled="btnDisable"
                      dark
                      class="pa-10"
                  >
                    <span style="font-weight: bold;font-size: 20px">บันทึกและเสนอแผน</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card>
      </v-expand-x-transition>
      <div id="printForm" v-html="editorData" class="d-none d-print-block"></div>
      <template>
        <v-dialog
            v-model="dialogLecturer"
            fullscreen
            transition="dialog-bottom-transition"
        >
          <v-card style="padding-bottom: 20px">
            <v-card-title>
              <v-btn
                  icon
                  @click="dialogLecturer = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <span style="font-weight: bold;color: black">
                                        แบบฟอร์มการเป็นวิทยากร/คณะกรรมการ
                                      </span>
            </v-card-title>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field label="หัวข้อเรื่อง / หน้าที่" v-model="SubjectForLecturer"
                                :error="SubjectForLecturer == ''"
                                :error-messages="SubjectForLecturer == '' ? 'หัวข้อเรื่อง / หน้าที่ ห้ามว่าง' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่เริ่มต้นจัดงาน"
                                v-model="dateSForLecturer"
                                :error="dateSForLecturer == ''"
                                :error-messages="dateSForLecturer == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่สิ้นสุดจัดงาน"
                                v-model="dateEForLecturer"
                                :error="dateEForLecturer == ''"
                                :error-messages="dateEForLecturer == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่เดินทาง"
                                v-model="dateSTravelForLecturer"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="date" label="วันที่กลับ"
                                v-model="dateETravelForLecturer"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="time" label="เวลาเริ่มต้น"
                                v-model="timeSForLecturer"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex justify-center" cols="12"
                       md="6">
                  <v-text-field type="time" label="เวลาสิ้นสุด"
                                v-model="timeEForLecturer"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col class="d-flex justify-center" cols="12"
                       md="10">
                  <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm2"></v-textarea>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-file-input
                  v-model="filesExpert"
                  color="deep-purple accent-4"
                  counter
                  label="แนบไฟล์เอกสารประกอบ"
                  multiple
                  placeholder="เลือกไฟล์"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="FileSelectExpert"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                      v-if="index < 5"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                  >
                    {{ text }}
                  </v-chip>

                  <span
                      v-else-if="index === 5"
                      class="overline grey--text text--darken-3 mx-2"
                  >
                                  +{{ filesExpert.length - 2 }} File(s)
                                </span>
                </template>
              </v-file-input>
            </v-list-item>
            <v-list-item>
              <v-alert
                  v-if="alertExpert"
                  prominent
                  type="error"
              >
                <v-row align="center" v-for="item in txtAlertExpert" :key="item.id">
                  <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                </v-row>
              </v-alert>
            </v-list-item>
            <v-list-item v-if="FileProjectExpert.length > 0">
              <template>
                <v-row class="d-flex justify-center">
                  <v-col cols="12" md="12">
                    <v-list>
                      <v-list-item-title>
                        ไฟล์ภาพประกอบ
                      </v-list-item-title>
                      <v-list-item>
                        <v-data-table
                            :items="FileProjectExpert"
                            :headers="FileHeader"
                            style="width: 100%"
                        >
                          <template v-slot:item.action="{ item }">
                            <v-list-item class="justify-space-around">
                              <v-btn text @click="ShowData(item.src)" color="green">
                                เรียกดู
                              </v-btn>
                              <v-btn @click="DeleteFile2(item)" text color="red">
                                ลบ
                              </v-btn>
                            </v-list-item>
                          </template>
                        </v-data-table>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </template>
            </v-list-item>
            <div align="center">
              <v-btn outlined color="primary" @click="AddWorkGuest">เพิ่มข้อมูล</v-btn>
            </div>
            <v-list-item class="d-flex justify-center" style="margin-top: 20px">
              <v-data-table :items="Lecturer" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                      </v-btn>
                    </div>
                    <div>
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_travel_start="{item}">
                  <span v-if="item.date_travel_start != '' && item.date_travel_start != null">{{
                      item.date_travel_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_travel_end="{item}">
                  <span v-if="item.date_travel_end != '' && item.date_travel_end != null">{{
                      item.date_travel_end | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span v-if="item.date_start != '' && item.date_start != null">{{
                      item.date_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span v-if="item.date_end != '' && item.date_end != null">{{ item.date_end | dateToThai }}</span>
                </template>
              </v-data-table>
            </v-list-item>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  outlined
                  color="green darken-2"
                  @click="InsertCoordinator(true)"
              >
                บันทึก
              </v-btn>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturer = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <div>
          <vue-html2pdf
              :show-layout="false"
              :float-layout="true"
              :enable-download="false"
              :preview-modal="true"
              :paginate-elements-by-height="1400"
              filename="Ori"
              :pdf-quality="2"
              :manual-pagination="false"
              pdf-format="a4"
              pdf-orientation="portrait"
              pdf-content-width="800px"

              @progress="onProgress($event)"
              @hasStartedGeneration="hasStartedGeneration()"
              @hasGenerated="hasGenerated($event)"
              ref="html2Pdf"
          >
            <section slot="pdf-content">
              <div style="color: black;margin-top: -520px" v-html="editorData">

              </div>
              <section style="display: flex;">
                <p style="color: black">test</p>
              </section>
              <!--              <p style="color: black" v-for="(val, key) in 58" :key="key">mดสอบดดดดดดดดดดดด {{val}}</p>-->
            </section>
          </vue-html2pdf>
        </div>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร/คณะกรรมการ</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                      </v-btn>
                    </div>
                    <div>
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_travel_start="{item}">
                  <span v-if="item.date_travel_start != '' && item.date_travel_start != null">{{
                      item.date_travel_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_travel_end="{item}">
                  <span v-if="item.date_travel_end != '' && item.date_travel_end != null">{{
                      item.date_travel_end | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span v-if="item.date_start != '' && item.date_start != null">{{
                      item.date_start | dateToThai
                    }}</span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span v-if="item.date_end != '' && item.date_end != null">{{ item.date_end | dateToThai }}</span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-snackbar
          v-model="snack"
          :timeout="3000"
          :color="snackColor"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
              v-bind="attrs"
              text
              @click="snack = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            :color="appColor"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import VueHtml2pdf from 'vue-html2pdf'
import Vue from "vue";
import queryString from "query-string";
// import AllFuncG from '@/FuncGlobal/ALlFunc'

export default {
  name: "InsertPlanProject",
  components: {
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
    VueHtml2pdf
  },
  data() {
    return {
      Project_code_ref: '',
      projectPlanAllData: [],
      YearSel: null,
      FiscalYearMenuData: [],
      chooseTypePlan: '1',
      dialogLoading: false,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      isPlan: null,
      isPlanCordi: false,
      episode: null,
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: null,
      Project_plan: [],
      Project_plan2: [],
      TypeCreateProject: '1',
      FiscalYearData: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      CheckSubAdmin: false,
      CheckAdmin: false,
      Rm2: '',
      WorkGroupData: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      FileHeader: [
        {text: 'ชื่อไฟล์', value: 'name'},
        {text: 'ประเภทไฟล์', value: 'type'},
        {text: '', value: 'action'},
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      filesExpert: [],
      alertExpert: false,
      txtAlertExpert: [],
      FileProjectExpert: '',
      dateSTravelForLecturer: '',
      dateETravelForLecturer: '',
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      formprint1: '', // หลักการและเหตุผล
      formprint2: '', // วัตถุประสงค์
      formprint3: '', // กลุ่มเป้าหมาย
      formprint4: '', // วิธีการจัดอบรม
      formprint5: '', // ระยะเวลาการจัดอบรม
      formprint6: '', // สถานที่จัดอบรม
      formprint7: '', // ผลที่คาดว่าจะได้รับ
      formprint8: '', // ผู้รับผิดชอบโครงการ
      formprint9: '', // ผู้รับผิดชอบโครงการ
      formprint10: '', // วิทยากร
      formprint11: '', // งบประมาณ
      formprint12: '', // หมายเหตุ
      editor: DecoupledEditor,
      editorData: '',
      editorConfig: {
        // The configuration of the editor.
        /*plugins: [Alignment, ExportPdf, CKFinder, Autoformat, Bold, Italic, Underline, Strikethrough, Code, Subscript, Superscript,
          BlockQuote, EasyImage, Font, Heading, Highlight, Image, Indent, IndentBlock, List, Mediaembed, Pastefromoffice,
          Undo, Table, Typing, ExportWord, PageBreak, paragraph, HtmlEmbed, Enter, ShiftEnter],
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'indent',
            'outdent',
            '|',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            'fontFamily',
            'CKFinder',
            'removeFormat',
            'pageNavigation',
            'restrictedEditing',
            'alignment',
            'specialCharacters',
            'strikethrough',
            'code',
            'superscript',
            'subscript',
            'pageBreak',
            'exportWord',
            'exportPdf',
            'todoList',
            'trackChanges',
            'codeBlock',
            'comment',
            'fontBackgroundColor',
            'fontColor',
            'fontSize',
            'highlight',
            'horizontalLine',
            'htmlEmbed',
            'imageInsert',
            'MathType',
            'ChemType',
            'pageBreak',
            'previousPage',
            'nextPage'
          ]
        },*/
        language: 'th',
        fontFamily: {
          options: [
            'default',
            'Arial, Helvetica, sans-serif',
            'Courier New, Courier, monospace',
            'Georgia, serif',
            'Lucida Sans Unicode, Lucida Grande, sans-serif',
            'Tahoma, Geneva, sans-serif',
            'Times New Roman, Times, serif',
            'Trebuchet MS, Helvetica, sans-serif',
            'Verdana, Geneva, sans-serif',
            'THSarabunNew'
          ]
        },
        fontSize: {
          options: [
            2,
            4,
            8,
            16,
            18,
            20,
            22,
            24,
            28,
            32,
            48,
            56,
            64
          ]
        },
        // indentBlock: {
        //   offset: 1,
        //   unit: 'em',
        //   classes: [
        //     'custom-block-indent-a', // First step - smallest indentation.
        //     'custom-block-indent-b',
        //     'custom-block-indent-c'  // Last step - biggest indentation.
        //   ]
        // }
      },
      Expense: 0,
      btnDisable: false,
      snack: false,
      snackColor: '',
      snackText: '',
      ReqMoney: '',
      Rm: '',
      selection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      CompetencyDataDump: [],
      ProjectData_U: [],
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      studentData: [],
      studentUniData: [],
      AllDepartData: [],
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      ApproveRadio: '1',
      DepSelect: null,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      tabPersonal: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: '', value: 'action'}
      ],
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      CheckStep3: true,
      e1: 1,
      steps: 8,
      vertical: false,
      altLabels: false,
      editable: true,
      full_name: '',
      phone: '',
      perid: '',
      peridCost: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      workAgeStart_Condi: '',
      workAgeEnd_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: null,
      course_group: '',
      FiscalYear: '',
      IsProcess: null,
      Project_category: '1',
      Project_type: '1',
      WorkBy: '',
      WorkByName: '',
      WorkByPhone: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '0',
      CalCredit: '0',
      PLACE: '',
      Province_id: '',
      Status: '',
      Objective: '',
      TargetGroup: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Ref_Project_code: '',
        Project_name: '',
        Course_code: null,
        course_group: '',
        IsProcess: null,
        Project_category: '',
        Project_type: '',
        WorkBy: '',
        WorkByName: '',
        WorkByPhone: '',
        Location: '',
        DatePeriod: '1',
        DateStart: '',
        DateEnd: '',
        CalHourse: '0',
        CalCredit: '0',
        PLACE: '',
        Province_id: '',
        Status: '0',
        Objective: '',
        TargetGroup: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        Project_group: '',
        Approve: '1',
        FiscalYear: '',
        IsPlan: '',
        IsPlanStatus: '0',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        Create_By: '',
        Create_Time: '',
        Update_By: '',
        Update_Time: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร/คณะกรรมการ/นำเสนอผลงาน', value: 'Lecturer'},
        {text: '', value: 'action'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'},
        {text: '', value: 'action'},
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'workAgeStart'},
        {text: 'อายุงานสิ้นสุด', value: 'workAgeEnd'},
        {text: '', value: 'action'},
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในประเทศ'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
        {text: '', value: 'action'}
      ],
      JoinPerson: [],
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      }
    }
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    vertical() {
      this.e1 = 2
      requestAnimationFrame(() => this.e1 = 1) // Workarounds
    },
  },
  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      ProjectPlanApproveData: 'Project/getProjectPlanApprove',
      projectForApprove: 'Project/getProjectForApprove',
      allPlanProj: 'Project/getAllPlanProjFormFiscalYear',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      ApproveMaster: 'Staff/getApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      DateForPlan: 'Project/getDateForPlan',
      TypeProject: 'Project/getTypeProject',
      StatusProject: 'Project/getStatusProject',
      appColor: 'Page/getColor',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectPlanData: 'Project/initProjectPlanData',
      initAllPlanProjectDataForApprove: 'Project/initAllPlanProjectDataForApprove',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initProjAllPlanDataFromFiscalYear: 'Project/initProjAllPlanDataFromFiscalYear',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initDateForPlan: 'Project/initDateForPlan',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    changeDate() {
      switch (this.episode) {
        case '1':
          this.DateStart = (parseInt(this.FiscalYear) - 1) + '-10-01'
          this.DateEnd = (parseInt(this.FiscalYear) - 1) + '-12-31'
          break
        case '2':
          this.DateStart = this.FiscalYear + '-01-01'
          this.DateEnd = this.FiscalYear + '-03-31'
          break
        case '3':
          this.DateStart = this.FiscalYear + '-04-01'
          this.DateEnd = this.FiscalYear + '-06-30'
          break
        case '4':
          this.DateStart = this.FiscalYear + '-07-01'
          this.DateEnd = this.FiscalYear + '-09-30'
          break
        default:
          this.DateStart = (parseInt(this.FiscalYear) - 1) + '-10-01'
          this.DateEnd = this.FiscalYear + '-09-30'
          break
      }
    },
    ClearData() {
      this.ProjectPlan = null
      this.Project_code = ''
      this.Project_name = ''
      this.Course_code = null
      this.course_group = ''
      this.IsProcess = null
      this.Project_category = '1'
      this.Project_type = '1'
      this.Objective = ''
      this.TargetGroup = ''
      this.Remarks = ''
      this.CalCredit = '0'
      this.CalHourse = '0'
      this.PLACE = ''
      this.Province_id = ''
      this.Country_id = ''
      this.BudgetRequest = ''
      this.Location = ''
      this.WorkBy = ''
      this.WorkByName = ''
      this.WorkByPhone = ''
      this.DateStart = ''
      this.DateEnd = ''
      this.DepSelect = null
      this.Project_group = ''
      this.FiscalYear = ''
      this.itemCode = ''
      this.FileProject = []
      this.files = []
      this.txtAlert = []
      this.alert = false
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    AddDepQuotaData() {
      var CheckMatch = []
      if (this.DepQuotaSelect != '' && this.DepQuotaCount != '') {
        if (!this.ChkJoinPerson && (parseInt(this.DepQuotaCount) > parseInt(this.ProjectQuotaCount))) {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด'
          })
        } else {
          if (parseInt(this.DepQuotaCount) > 0) {
            CheckMatch = this.DepQuotaData.filter(item => item.dep_group_id == this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id)
            if (CheckMatch.length > 0) {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อมูลหน่วยงาน อยู่แล้วไม่สามารถบันทึกข้อมูลหน่วยงานเพิ่มได้อีก'
              })
            } else {
              var type = ''
              if (this.ChooseTypeDep == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: this.ChooseTypeDep,
                type: type,
                type_id: this.ChooseTypeDep,
                dep_name: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id,
                count: this.DepQuotaCount
              })

              this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount)
              this.DepQuotaSelect = ''
              this.DepQuotaCount = ''
            }
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุจำนวนผู้เข้าร่วมอย่างน้อย 1 คน'
            })
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลหน่วยงาน และจำนวนผู้เข้าร่วมให้ครบถ้วน'
        })
      }
    },
    RemoveJoinProject() {
      if (this.JoinPerson.length > 0) {
        this.JoinPerson = []
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    GetPlanToForm() {
      this.Project_code_ref = ''
      this.Project_code = ''
      this.Project_name = ''
      this.Project_code_dump = ''
      this.Course_code = ''
      this.course_group = ''
      this.IsProcess = null
      this.Project_category = '1'
      this.Project_type = '1'
      this.Objective = ''
      this.TargetGroup = ''
      this.Remarks = ''
      this.CalCredit = '0'
      this.CalHourse = '0'
      this.PLACE = ''
      this.Province_id = ''
      this.Country_id = ''
      this.BudgetRequest = ''
      this.Location = ''
      this.WorkBy = ''
      this.WorkByName = ''
      this.WorkByPhone = ''
      this.DateStart = ''
      this.DateEnd = ''
      this.DepSelect = null
      this.Project_group = ''
      this.FiscalYear = ''
      this.episode = null
      this.isPlan = null
      this.itemCode = ''
      this.FileProject = []
      this.files = []
      this.txtAlert = []
      this.alert = false
      if (this.ProjectPlan != null) {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_view/Project_code/' + this.ProjectPlan).then(res => {
          if (res.data) {
            this.Project_code = res.data.Project_code
            this.Project_code_ref = res.data.Project_code
            this.Project_code_dump = res.data.Project_code
            this.Project_name = res.data.Project_name
            if (res.data.Course_code == '' || res.data.Course_code == null) {
              this.Course_code = null
            } else {
              this.Course_code = res.data.Course_code
            }
            this.course_group = res.data.Course_group
            this.IsProcess = res.data.IsProcess
            this.Project_category = res.data.Project_category
            this.Project_type = res.data.Project_type
            this.Objective = res.data.Objective
            this.TargetGroup = res.data.TargetGroup
            this.Remarks = res.data.Remarks
            this.CalCredit = '' + res.data.CalCredit
            this.CalHourse = '' + res.data.CalHourse
            this.PLACE = res.data.PLACE
            this.Province_id = res.data.Province_id
            this.Country_id = res.data.Country_id
            this.BudgetRequest = res.data.BudgetRequest
            this.Location = res.data.Location
            this.WorkBy = res.data.WorkBy
            this.WorkByName = res.data.WorkByName
            this.WorkByPhone = res.data.WorkByPhone
            this.episode = ((res.data.DatePeriod == '' || res.data.DatePeriod == null) ? null : res.data.DatePeriod)
            this.DateStart = res.data.DateStart
            this.DateEnd = res.data.DateEnd
            this.DepSelect = res.data.Dep_Code
            this.Project_group = res.data.Project_group
            this.FiscalYear = parseInt(res.data.FiscalYear)
            this.itemCode = res.data.Item_Code
            this.isPlan = res.data.IsPlan

            this.SelProjectGroup()
            this.getCourseType()
            this.getCompetency()

            /*if ((this.DateStart == (parseInt(this.FiscalYear) - 1) + '-10-01') && (this.DateEnd == (parseInt(this.FiscalYear) - 1) + '-12-31')) {
              this.episode = '1'
            } else if ((this.DateStart == this.FiscalYear + '-01-01') && (this.DateEnd == this.FiscalYear + '-03-31')) {
              this.episode = '2'
            } else if ((this.DateStart == this.FiscalYear + '-04-01') && (this.DateEnd == this.FiscalYear + '-06-30')) {
              this.episode = '3'
            } else if ((this.DateStart == this.FiscalYear + '-07-01') && (this.DateEnd == this.FiscalYear + '-09-30')) {
              this.episode = '4'
            } else {
              this.episode = null
            }*/

            // axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/' + this.ProjectPlan).then(res => {
            //   if (res.data) {
            //     if (res.data.length > 0) {
            //       res.data.map((item) => {
            //         switch (item.File_type) {
            //           case 'image/jpg':
            //           case 'image/jpeg':
            //           case 'image/gif':
            //           case 'image/bmp':
            //           case 'image/png':
            //             this.FileProject.push({
            //               id: item.id,
            //               name: item.File_name,
            //               src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
            //               path: item.File_path,
            //               type: 'image',
            //               type_Img: item.File_type
            //             })
            //             break
            //           case 'application/pdf':
            //             this.FileProject.push({
            //               id: item.id,
            //               name: item.File_name,
            //               src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
            //               path: item.File_path,
            //               type: 'pdf',
            //               type_Img: item.File_type
            //             })
            //             break
            //           default:
            //             break
            //         }
            //       })
            //     } else {
            //       switch (res.data.File_type) {
            //         case 'image/jpg':
            //         case 'image/jpeg':
            //         case 'image/gif':
            //         case 'image/bmp':
            //         case 'image/png':
            //           this.FileProject.push({
            //             id: res.data.id,
            //             name: res.data.File_name,
            //             src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
            //             path: res.data.File_path,
            //             type: 'image',
            //             type_Img: res.data.File_type
            //           })
            //           break
            //         case 'application/pdf':
            //           this.FileProject.push({
            //             id: res.data.id,
            //             name: res.data.File_name,
            //             src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
            //             path: res.data.File_path,
            //             type: 'pdf',
            //             type_Img: res.data.File_type
            //           })
            //           break
            //         default:
            //           break
            //       }
            //     }
            //   } else {
            //     this.FileProject = []
            //   }
            // })
          }
        })
      }
    },
    CheckPlace() {
      if (this.PLACE == '2') {
        this.Country_id = ''
      } else if (this.PLACE == '3') {
        this.Province_id = ''
      }
    },
    CheckKeyPress(event) {
      if (event.key == "Enter") {
        console.log('here')
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({name: 'PrintFormProject', query: {data: this.editorData}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.Project_group == '108' || this.Project_group == '109') {
        this.rdoRegisterProject = '1'
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map(item => {
            item.status_reg = '1'
          })
        }
      } else {
        this.rdoRegisterProject = '0'
      }
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      // if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
      //     && this.dateSTravelForLecturer != '' && this.dateETravelForLecturer != ''
      //     && this.dateEForLecturer != '' && this.timeSForLecturer != ''
      //     && this.timeEForLecturer != '') {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
          && this.dateEForLecturer != '') {
        this.Lecturer.push({
          id: this.Lecturer.length,
          perid: this.perid,
          Project_code: this.Project_code,
          Project_name: this.Project_name,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer,
          full_Name: this.staffData.filter(item => item.perid == this.perid)[0].full_Name,
          date_travel_start: this.dateSTravelForLecturer,
          date_travel_end: this.dateETravelForLecturer,
          type: this.Committee_code,
          type_name: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
          files: this.FileProjectExpert,
          Rm: this.Rm2
        })
        this.SubjectForLecturer = ''
        this.dateSTravelForLecturer = ''
        this.dateETravelForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
        this.FileProjectExpert = []
        this.filesExpert = []
        this.txtAlertExpert = []
        this.Rm2 = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
      );
    },
    save() {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close() {
      console.log('Dialog closed')
    },
    AddExpenseData() {
      if (this.BudgetRequest != '') {
        if (this.expenseCost == '' && this.ReqMoney == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาระบุรายการค่าใช้จ่าย และ จำนวนเงิน ให้ครบถ้วน'
          })
        } else {
          if ((this.Expense + parseInt(this.ReqMoney)) > parseInt(this.BudgetRequest)) {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุค่าใช้จ่าย ห้ามเกินงบประมาณที่ขอ'
            })
          } else {
            this.Expense += parseInt(this.ReqMoney)
            var ResultExpenseData = this.expense_Data.filter(item => item.Expense_id == this.expenseCost)
            if (ResultExpenseData.length > 0) {
              this.budgetData.push({
                index: (this.budgetData.length + 1),
                Expense_id: ResultExpenseData[0].Expense_id,
                Expense_des: ResultExpenseData[0].Expense_des,
                ReqMoney: this.ReqMoney,
                Rm: this.Rm,
              })

              this.expenseCost = ''
              this.ReqMoney = ''
              this.Rm = ''
            }
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุงบประมาณในการจัด'
        })
      }
    },
    DelExpense(item) {
      this.budgetData.map((bud_I, idx) => {
        if (bud_I.Expense_id == item.Expense_id) {
          this.Expense -= parseInt(item.ReqMoney)
          this.budgetData.splice(idx, 1)
        }
      })
    },
    ShowDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    onResize() {
      this.isMobile = window.innerWidth < 600
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s()
      }
    },
    insertPersonUni() {
      this.personalMedData.map(value => {
        if (this.IdPersonal == value.STAFF_ID) {
          this.JoinPerson.push({
            ...value,
            uid: value.STAFF_ID,
            full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
            name: value.STAFF_NAME_THAI,
            sname: value.STAFF_SNAME_THAI,
            idCard: value.STAFF_PERS_ID,
            affiliation: value.FAC_NAME_THAI,
            position: '',
            phone: '',
            registerType_id: 2,
          })
          this.IdPersonal = ''
        }
      })
    },
    insertStd(msg) {
      if (msg == 'med') {
        this.studentData.map(value => {
          if (this.Idstudent == value.STUDENT_ID) {
            this.JoinPerson.push({
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: 'คณะแพทยศาสตร์',
              position: '',
              phone: '',
              registerType_id: 1,
            })
            this.Idstudent = ''
          }
        })
      } else {
        this.studentUniData.map(value => {
          if (this.IdstudentUni == value.STUDENT_ID) {
            this.JoinPerson.push({
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: value.FAC_NAME_THAI,
              position: '',
              phone: '',
              registerType_id: 3,
            })
            this.IdstudentUni = ''
          }
        })
      }
    },
    Del_item(item) {
      this.JoinPerson = this.JoinPerson.filter(value => value.uid != item.uid)
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    ChooseEmpolyee_c(event) {
      var GetData = []
      if (event.key == "Enter") {
        GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
        if (GetData.length > 0) {
          GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
          this.JoinPerson.push({
            ...GetData[0],
            uid: GetData[0].perid,
            name: GetData[0].name,
            sname: GetData[0].surname,
            idCard: GetData[0].citizen_id,
            affiliation: GetData[0].dep_name,
            position: '',
            phone: '',
            registerType_id: 0,
          })
          this.cardSel = ''
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      // var CheckQuotaProject = false
      var CheckGroupExample = []
      if (!this.ChkJoinPerson && this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
        })
      } else {
        this.staffData.map((staff_I) => {
          if (staff_I.perid == this.staffSel) {
            if (this.DataCondi.length > 0) {
              CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

              if (CheckGroupExample.length > 0) {
                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map((dep_quota, idx) => {
                    if (dep_quota.type_id == '0' && !CheckDepMatch) {
                      if (staff_I.dep_id == dep_quota.dep_id) {
                        CheckDepMatch = true
                        if (this.JoinPerson.length > 0) {
                          if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }

                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.staffSel = ''
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          if (this.ChkJoinPerson) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.staffSel = ''
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                              })
                            }
                          }
                        }
                      }
                    } else {
                      //// ตรงนี้ต้องเช็ค
                      if (!CheckDepMatch) {
                        var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                        if (DepGroup.length > 0) {
                          if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                            CheckDepMatch = true
                            if (this.JoinPerson.length > 0) {
                              if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: '',
                                    phone: '',
                                    registerType_id: 0,
                                  })
                                  this.staffSel = ''
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                                })
                              }
                            } else {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            }
                          }
                        }
                      }
                    }
                  })
                } else {
                  if (this.JoinPerson.length < parseInt(this.ProjectQuotaCount)) {
                    if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.JoinPerson.unshift({
                        ...staff_I,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg: this.rdoRegisterProject,
                        position: '',
                        phone: '',
                        registerType_id: 0,
                      })
                      this.staffSel = ''
                    } else {
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                      })
                    }
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
                    })
                  }
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
                })
              }
            } else if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((dep_quota, idx) => {
                if (dep_quota.type_id == '0' && !CheckDepMatch) {
                  if (staff_I.dep_id == dep_quota.dep_id) {
                    CheckDepMatch = true
                    if (this.JoinPerson.length > 0) {
                      if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }

                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                        })
                      }
                    } else {
                      if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.JoinPerson.unshift({
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg: this.rdoRegisterProject,
                          position: '',
                          phone: '',
                          registerType_id: 0,
                        })
                        this.staffSel = ''
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    }
                  } else {
                    if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                      if (this.ChkJoinPerson) {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.staffSel = ''
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                          })
                        }
                      }
                    }
                  }
                } else {
                  //// ตรงนี้ต้องเช็ค
                  if (!CheckDepMatch) {
                    var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                    if (DepGroup.length > 0) {
                      if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                        CheckDepMatch = true
                        if (this.JoinPerson.length > 0) {
                          if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        }
                      }
                    }
                  }
                }
              })
            } else {
              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  ...staff_I,
                  uid: staff_I.perid,
                  name: staff_I.name,
                  sname: staff_I.surname,
                  idCard: staff_I.citizen_id,
                  affiliation: staff_I.dep_name,
                  status_reg: this.rdoRegisterProject,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                })
                this.staffSel = ''
              } else {
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          }
        })
      }
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    insertDataPerson(type) {
      if (type == 'person') {
        this.JoinPerson.push({
          uid: 'P_' + this.JoinPerson.length,
          full_Name: this.NameP + ' ' + this.SurNameP,
          name: this.NameP,
          sname: this.SurNameP,
          idCard: this.idCard,
          affiliation: this.affiliation,
          position: this.position,
          phone: '',
          registerType_id: 4,
        })
        this.NameP = ''
        this.SurNameP = ''
        this.idCard = ''
        this.affiliation = ''
        this.position = ''
      } else {
        this.JoinPerson.push({
          uid: 'S_' + this.JoinPerson.length,
          full_Name: this.NameStd + ' ' + this.SurNameStd,
          name: this.NameStd,
          sname: this.SurNameStd,
          idCard: this.idCardStd,
          affiliation: this.affiliationStd,
          position: '',
          phone: '',
          registerType_id: 5,
        })
        this.NameStd = ''
        this.SurNameStd = ''
        this.idCardStd = ''
        this.affiliationStd = ''
      }
    },
    SaveToTable() {
      // this.EmpData.map((item) => {
      //   this.JoinPerson.push({
      //     ...item,
      //     uid: item.perid,
      //     name: item.name,
      //     sname: item.surname,
      //     idCard: item.citizen_id,
      //     affiliation: item.dep_name,
      //     position: '',
      //     phone: '',
      //     registerType_id: 0,
      //   })
      // })
      // this.EmpData = []
      // this.items = []
      // this.departSel = ''
      var CheckDupe = false
      var CheckDepMatch = false
      var CheckGroupExample = []
      this.ShowAlertSuc = false
      this.ShowAlertErr = false
      this.MessageSuc = ''
      this.MessageError = ''

      if (this.ChkJoinPerson && this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่กำหนด'
        })
      } else {
        this.EmpData.map((item, EmpIdx) => {
          CheckDupe = false
          CheckDepMatch = false
          CheckGroupExample = []
          this.staffData.map((staff_I) => {
            if (staff_I.perid == item.perid) {
              if (this.DataCondi.length > 0) {
                CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

                if (CheckGroupExample.length > 0) {
                  if (this.DepQuotaData.length > 0) {
                    this.DepQuotaData.map((dep_quota, idx) => {
                      if (dep_quota.type_id == '0' && !CheckDepMatch) {
                        if (staff_I.dep_id == dep_quota.dep_id) {
                          CheckDepMatch = true
                          if (this.JoinPerson.length > 0) {
                            if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }

                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          }
                        } else {
                          if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                            if (this.ChkJoinPerson) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: '',
                                    phone: '',
                                    registerType_id: 0,
                                  })
                                  this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                  this.ShowAlertSuc = true
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                this.ShowAlertErr = true
                              }
                            }
                          }
                        }
                      } else {
                        //// ตรงนี้ต้องเช็ค
                        if (!CheckDepMatch) {
                          var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                          if (DepGroup.length > 0) {
                            if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                              CheckDepMatch = true
                              if (this.JoinPerson.length > 0) {
                                if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.JoinPerson.unshift({
                                      ...staff_I,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_reg: this.rdoRegisterProject,
                                      position: '',
                                      phone: '',
                                      registerType_id: 0,
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              }
                            }
                          }
                        }
                      }
                    })
                  } else {
                    if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.JoinPerson.unshift({
                        ...staff_I,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg: this.rdoRegisterProject,
                        position: '',
                        phone: '',
                        registerType_id: 0,
                      })
                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                      this.ShowAlertSuc = true
                    } else {
                      this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                      this.ShowAlertErr = true
                    }
                  }
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: darkcyan">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ เงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก</p>'
                  this.ShowAlertErr = true
                }
              } else if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((dep_quota, idx) => {
                  if (dep_quota.type_id == '0' && !CheckDepMatch) {
                    if (staff_I.dep_id == dep_quota.dep_id) {
                      CheckDepMatch = true
                      if (this.JoinPerson.length > 0) {
                        if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }

                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                          this.ShowAlertErr = true
                        }
                      } else {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                          this.ShowAlertSuc = true
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                          this.ShowAlertErr = true
                        }
                      }
                    } else {
                      if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                        if (this.ChkJoinPerson) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        } else {
                          if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                            this.ShowAlertErr = true
                          }
                        }
                      }
                    }
                  } else {
                    //// ตรงนี้ต้องเช็ค
                    if (!CheckDepMatch) {
                      var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                      if (DepGroup.length > 0) {
                        if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                          CheckDepMatch = true
                          if (this.JoinPerson.length > 0) {
                            if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...staff_I,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    status_reg: this.rdoRegisterProject,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                  this.ShowAlertSuc = true
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                  this.ShowAlertErr = true
                }
              }
            }
          })
          if (EmpIdx == this.EmpData.length - 1) {
            this.EmpData = []
            this.items = []
            this.departSel = ''
          }
        })
      }
    },
    showDetails: function (item) {
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        this.project = item
        this.Details_Cordi = true;
      }
    },
    DeleteCompetency(item) {
      this.competency_DataForSubmit = this.competency_DataForSubmit.filter(value => value.Competency_code != item.Competency_code)
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
              // case 'image/jpg':
              // case 'image/jpeg':
              // case 'image/gif':
              // case 'image/bmp':
              // case 'image/png':
              //   Checkfile = true;
              //   break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                  // case 'image/jpg':
                  // case 'image/jpeg':
                  // case 'image/gif':
                  // case 'image/bmp':
                  // case 'image/png':
                  //   this.FileProject.push({
                  //     name: item.name,
                  //     src: URL.createObjectURL(item),
                  //     path: res.data.path,
                  //     type: 'image',
                  //     type_Img: item.type
                  //   })
                  //   break
                case 'application/pdf':
                  this.FileProject.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileProjectPdf = []
              //     this.FileProject = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }

    },
    FileSelectExpert: function () {
      // var count = 0
      this.txtAlert = []
      this.FileProjectExpert = []
      this.alertExpert = false
      if (this.filesExpert.length > 0) {
        this.filesExpert.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlertExpert.push({
                id: this.txtAlertExpert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
            }
          } else {
            this.txtAlertExpert.push({
              id: this.txtAlertExpert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlertExpert.length == 0) {
        this.filesExpert.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProjectExpert.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type
                  })
                  break
                case 'application/pdf':
                  this.FileProjectExpert.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileProjectPdf = []
              //     this.FileProject = []
              // }
            }
          })
        })

      } else {
        this.alertExpert = true
      }
    },
    DeleteExpense_p(item) {
      this.expense_p_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_p_DataForSubmit.splice(idx, 1)
        }
      })
    },
    DeleteExpense(item) {
      this.expense_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_DataForSubmit.splice(idx, 1)
        }
      })
    },
    InsertCompetency() {
      if (this.Competency_code == '' || this.UPercent == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
        })
      } else {
        if (this.competency_DataForSubmit.length > 0) {
          this.competency_DataForSubmit.map((compe_i_s) => {
            if (compe_i_s.Competency_code == this.Competency_code) {
              this.$swal.fire({
                icon: 'error',
                title: 'มี Competency นี้อยู่แล้ว !! ไม่สามารถเพิ่มข้อมูลได้อีก'
              })
            } else {
              this.Competency_Data.map((compe_i) => {
                if (compe_i.Competency_code == this.Competency_code) {
                  this.competency_DataForSubmit.push({
                    Project_code: this.Project_code,
                    Competency_code: this.Competency_code,
                    Competency_des: compe_i.Competency_des,
                    UPercent: this.UPercent,
                  })
                }
              })
            }
          })
        } else {
          this.Competency_Data.map((compe_i) => {
            if (compe_i.Competency_code == this.Competency_code) {
              this.competency_DataForSubmit.push({
                Project_code: this.Project_code,
                Competency_code: this.Competency_code,
                Competency_des: compe_i.Competency_des,
                UPercent: this.UPercent,
              })
            }
          })
        }
      }
      this.Competency_code = ''
      this.UPercent = ''
    },
    AddExpense() {
      var CheckDupe = false
      var CheckDupeExpense = false
      var CheckDep = false
      if (this.radioGroup2 == '0') {
        if (this.moneyCost == '' || this.expenseCost == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
          })
        } else {
          if (this.expense_p_DataForSubmit.length > 0) {
            this.expense_p_DataForSubmit.map((item) => {
              item.Expense_data.map((item_expense) => {
                if (item_expense.Expense_id == this.expenseCost) {
                  CheckDupe = true
                }
              });
            })
          }
          if (CheckDupe) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว'
            })
          } else {
            if (this.expense_p_DataForSubmit.length > 0) {
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                    CheckDep = true
                  }
                })
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: '',
                        Dep_Cost_Name: '',
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost
                      })
                      item.SumCost += parseInt(this.moneyCost)
                      this.expenseCostSum += parseInt(this.moneyCost)
                    }
                  })
                }
              })
            } else {
              this.expense_p_DataForSubmit.push({
                id: this.expense_p_DataForSubmit.length + 1,
                Project_code: this.Project_code,
                SumCost: 0,
                Expense_data: []
              })
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                    CheckDep = true
                  }
                })
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: '',
                        Dep_Cost_Name: '',
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost
                      })
                      item.SumCost += parseInt(this.moneyCost)
                      this.expenseCostSum += parseInt(this.moneyCost)
                    }
                  })
                }
              })
            }
          }
          this.peridCost = ''
          this.moneyCost = ''
          this.expenseCost = ''
        }
      } else {
        if (this.peridCost == '' || this.moneyCost == '' || this.expenseCost == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
          })
        } else {
          if (this.expense_DataForSubmit.length > 0) {
            this.expense_DataForSubmit.map((item) => {
              if (item.PERID == this.peridCost) {
                CheckDupe = true
                this.expense_p_DataForSubmit.map((item) => {
                  item.Expense_data.map((item_expense) => {
                    if (item_expense.Expense_id == this.expenseCost) {
                      CheckDupeExpense = true
                    }
                  });
                })
              }
            })
          }
          if (CheckDupe) {
            if (CheckDupeExpense) {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว'
              })
            } else {
              if (this.expense_DataForSubmit.length > 0) {
                this.expense_DataForSubmit.map((item) => {
                  if (item.PERID == this.peridCost) {
                    CheckDep = false
                    this.depart.map((dep_i) => {
                      if (dep_i.dep_id == this.DepCost) {
                        this.expense_Data.map((expense_i) => {
                          if (expense_i.Expense_id == this.expenseCost) {
                            item.Expense_data.push({
                              Dep_Cost: this.DepCost,
                              Dep_Cost_Name: dep_i.dep_name,
                              Expense_id: this.expenseCost,
                              Expense_des: expense_i.Expense_des,
                              ReqMoney: this.moneyCost
                            })
                            item.SumCost += parseInt(this.moneyCost)
                            this.expenseCostSum += parseInt(this.moneyCost)
                          }
                        })
                        CheckDep = true
                      }
                    })
                    if (!CheckDep) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: '',
                            Dep_Cost_Name: '',
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost
                          })
                          item.SumCost += parseInt(this.moneyCost)
                          this.expenseCostSum += parseInt(this.moneyCost)
                        }
                      })
                    }
                  }
                })
              }
            }
          } else {
            this.staffData.map((staff_i) => {
              if (staff_i.perid == this.peridCost) {
                this.expense_DataForSubmit.push({
                  id: this.expense_DataForSubmit.length + 1,
                  PERID: this.peridCost,
                  full_Name: staff_i.full_Name,
                  Dep_Code: this.dep_id,
                  Dep_name: staff_i.dep_name,
                  Project_code: this.Project_code,
                  SumCost: 0,
                  Expense_data: []
                })
              }
            })
            if (this.expense_DataForSubmit.length > 0) {
              this.expense_DataForSubmit.map((item) => {
                if (item.PERID == this.peridCost) {
                  CheckDep = false
                  this.depart.map((dep_i) => {
                    if (dep_i.dep_id == this.DepCost) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: this.DepCost,
                            Dep_Cost_Name: dep_i.dep_name,
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost
                          })
                          item.SumCost += parseInt(this.moneyCost)
                          this.expenseCostSum += parseInt(this.moneyCost)
                        }
                      })
                      CheckDep = true
                    }
                  })
                  if (!CheckDep) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: '',
                          Dep_Cost_Name: '',
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                  }
                }
              })
            }
          }
          this.peridCost = ''
          this.moneyCost = ''
          this.expenseCost = ''
        }
      }
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
        if (this.e1 == 2) {
          if (this.Project_name == '' || this.Project_group == '' || this.PLACE == ''
              || this.WorkBy == '' || this.Location == ''
              || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
              || this.CalCredit == '' || this.CalHourse == '') {
            this.CheckStep1 = false
          } else {
            if (this.PLACE == '2' && this.Province_id == '') {
              this.CheckStep1 = false
            } else if (this.PLACE == '3' && this.Country_id == '') {
              this.CheckStep1 = false
            } else {
              this.CheckStep1 = true
            }
          }
        }

        if (this.e1 == 4) {
          if (this.Coordinator.length == 0) {
            this.CheckStep3 = false
          } else {
            this.CheckStep3 = true
          }
        }
        if (this.e1 == 7) {
          var GroupExample = ''
          var committeeTxt = ''
          var lecturerTxt = ''
          var budgetTxt = ''
          if (this.Committee_ToShow.length > 0) {
            this.Committee_ToShow.map((item, idx) => {
              committeeTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.Committee_des + '</span></p>'
            })
          }
          if (this.DataCondi.length > 0) {
            this.DataCondi.map((item, idx) => {
              if (item.workAgeStart != item.workAgeEnd) {
                GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
              } else {
                GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

              }
            })
          }
          if (this.LecturerToShow.length > 0) {
            this.LecturerToShow.map((item, idx) => {
              if (item.Perid != '') {
                if (this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv).length > 0) {
                  lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.pos_name + this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv)[0].LevelName + '</span></p>'
                } else {
                  lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
                }
              } else {
                lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
              }
            })
          }
          if (this.budgetData.length > 0) {
            this.budgetData.map((item, idx) => {
              if (item.Rm != '') {
                budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + '(' + item.Rm + ') &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
              } else {
                budgetTxt += '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
              }
              if (idx == this.budgetData.length - 1) {
                budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' + ' รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.Expense + '  บาท</span></p>'
              }
            })
          }
          if (this.DateStart == '' || this.DateEnd == '') {
            this.editorData = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'

          } else {
            this.editorData = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateStart) + '&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateEnd) + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'

          }
        }
      }
    },
    ExecForm() {
      var GroupExample = ''
      var committeeTxt = ''
      var lecturerTxt = ''
      var budgetTxt = ''
      if (this.Committee_ToShow.length > 0) {
        this.Committee_ToShow.map((item, idx) => {
          committeeTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.Committee_des + '</span></p>'
        })
      }
      if (this.DataCondi.length > 0) {
        this.DataCondi.map((item, idx) => {
          if (item.workAgeStart != item.workAgeEnd) {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
          } else {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

          }
        })
      }
      if (this.LecturerToShow.length > 0) {
        this.LecturerToShow.map((item, idx) => {
          if (item.Perid != '') {
            if (this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv).length > 0) {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.pos_name + this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv)[0].LevelName + '</span></p>'
            } else {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
            }
          } else {
            lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
          }
        })
      }
      if (this.budgetData.length > 0) {
        this.budgetData.map((item, idx) => {
          if (item.Rm != '') {
            budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + '(' + item.Rm + ') &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
          } else {
            budgetTxt += '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
          }
          if (idx == this.budgetData.length - 1) {
            budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' + ' รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.Expense + '  บาท</span></p>'
          }
        })
      }
      if (this.DateStart == '' || this.DateEnd == '') {
        this.editorData = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'

      } else {
        this.editorData = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateStart) + '&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateEnd) + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'

      }
    },
    DeleteCoordinator(data) {
      this.Coordinator.map((item, idx) => {
        if (item.name == data.name) {
          this.Coordinator.splice(idx, 1)
        }
      })
    },
    UpdateName(perid) {
      this.staffData.map((item) => {
        if (item.perid == perid) {
          this.full_name = item.full_Name
        }
      })
    },
    InsertCoordinator(Condi) {
      var committ_desc = ''

      if (this.full_name != '' && this.phone != '' && this.Committee_code != '') {

        if ((this.Committee_code == '5' || this.Committee_code == '6'
            || this.Committee_code == '10' || this.Committee_code == '11'
            || this.Committee_code == '12' || this.Committee_code == '13'
            || this.Committee_code == '14') && !Condi) {
          if (this.radioGroup == '1' || this.radioGroup == '3') {
            if (this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code)[0].committee_des
            }

            if (this.Coordinator.length > 0) {
              if (this.radioGroup == '0') {
                var CheckCupe = false
                this.Coordinator.map((CoorItem) => {
                  if (CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code) {
                    CheckCupe = true
                  }
                })
                if (CheckCupe) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
                  })
                } else {
                  this.staffData.map((item) => {
                    if (item.perid == this.perid) {
                      if (this.radioGroup == '0') {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: this.perid,
                          TEL: this.phone,
                        })
                      } else {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: '',
                          TEL: this.phone,
                        })
                      }
                    }
                  })
                  this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                  this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                  if (this.Committee_ToShow.length > 0) {
                    this.Committee_ToShow.map((Committee_i, idx) => {
                      Committee_i.index = (idx + 1)
                    })
                  }
                  if (this.LecturerToShow.length > 0) {
                    this.LecturerToShow.map((lecture_i, idx) => {
                      lecture_i.index = (idx + 1)
                    })
                  }
                  this.Committee_code = ''
                  this.perid = ''
                  this.full_name = ''
                  this.phone = ''
                }
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            } else {
              if (this.radioGroup == '0') {
                this.staffData.map((item) => {
                  if (item.perid == this.perid) {
                    if (this.radioGroup == '0') {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: this.perid,
                        TEL: this.phone,
                      })
                    } else {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: '',
                        TEL: this.phone,
                      })
                    }
                  }
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                if (this.Committee_ToShow.length > 0) {
                  this.Committee_ToShow.map((Committee_i, idx) => {
                    Committee_i.index = (idx + 1)
                  })
                }
                if (this.LecturerToShow.length > 0) {
                  this.LecturerToShow.map((lecture_i, idx) => {
                    lecture_i.index = (idx + 1)
                  })
                }
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            }
          } else {
            this.dialogLecturer = true
          }
        } else {
          if ((this.Committee_code == '5' || this.Committee_code == '6'
              || this.Committee_code == '10' || this.Committee_code == '11'
              || this.Committee_code == '12' || this.Committee_code == '13'
              || this.Committee_code == '14') && this.Lecturer.length == 0) {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณากรอกข้อมูลการเป็นวิทยากร/คณะกรรมการ/นำเสนอผลงาน'
            })
          } else {
            this.dialogLecturer = false
            this.WorkGroupData = this.WorkGroupData.concat(this.Lecturer)
            this.SubjectForLecturer = ''
            this.dateSTravelForLecturer = ''
            this.dateETravelForLecturer = ''
            this.dateSForLecturer = ''
            this.dateEForLecturer = ''
            this.timeSForLecturer = ''
            this.timeEForLecturer = ''
            this.FileProjectExpert = []
            this.filesExpert = []
            this.txtAlertExpert = []
            this.Lecturer = []

            if (this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code)[0].committee_des
            }

            if (this.Coordinator.length > 0) {
              if (this.radioGroup == '0') {
                CheckCupe = false
                this.Coordinator.map((CoorItem) => {
                  if (CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code) {
                    CheckCupe = true
                  }
                })
                if (CheckCupe) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
                  })
                } else {
                  this.staffData.map((item) => {
                    if (item.perid == this.perid) {
                      if (this.radioGroup == '0') {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: this.perid,
                          TEL: this.phone,
                        })
                      } else {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: '',
                          TEL: this.phone,
                        })
                      }
                    }
                  })
                  this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                  this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                  if (this.Committee_ToShow.length > 0) {
                    this.Committee_ToShow.map((Committee_i, idx) => {
                      Committee_i.index = (idx + 1)
                    })
                  }
                  if (this.LecturerToShow.length > 0) {
                    this.LecturerToShow.map((lecture_i, idx) => {
                      lecture_i.index = (idx + 1)
                    })
                  }
                  this.Committee_code = ''
                  this.perid = ''
                  this.full_name = ''
                  this.phone = ''
                }
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            } else {
              if (this.radioGroup == '0') {
                this.staffData.map((item) => {
                  if (item.perid == this.perid) {
                    if (this.radioGroup == '0') {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: this.perid,
                        TEL: this.phone,
                      })
                    } else {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: '',
                        TEL: this.phone,
                      })
                    }
                  }
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                if (this.Committee_ToShow.length > 0) {
                  this.Committee_ToShow.map((Committee_i, idx) => {
                    Committee_i.index = (idx + 1)
                  })
                }
                if (this.LecturerToShow.length > 0) {
                  this.LecturerToShow.map((lecture_i, idx) => {
                    lecture_i.index = (idx + 1)
                  })
                }
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            }
          }


        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณากรอกชื่อ-สกุล ตำแหน่ง และ เบอร์โทร,ของผู้ประสานงานให้ครบถ้วน'
        })
      }
    },
    getCourseType() {
      if (this.Project_type == '' || this.Project_type == null) {
        this.Project_type = this.TypeProject
      }
      if ((this.isPlan != '' && this.isPlan != null) && (this.Project_category != '' && this.Project_category != null) && (this.TypeProject == '1' || (this.TypeProject == '2' && (this.IsProcess != '' && this.IsProcess != null)))) {
        this.Project_code = ((parseInt(this.FiscalYear) + 543).toString().substring(2)) + '-' + this.Project_category + this.Project_type + this.isPlan + '1-' + '???'
      }
      if (this.Course_code == '') {
        this.course_group = ''
        // this.Project_code = ''
        this.Period_code = 0
        this.CalHourse = '0'
        this.CalCredit = '0'
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.Course_code) {
            this.course_group = item.Course_type_des
            this.Period_code = item.Period_code
            this.CalHourse = '' + item.Course_hour
            this.CalCredit = '' + item.General_credit
          }
        })
      }
      if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow() && item.year == this.FiscalYear).length > 0) {
        this.isPlan = '1'
        this.isPlanCordi = false
      } else {
        this.isPlan = '0'
        this.isPlanCordi = true
      }
    },
    getCompetency() {
      this.initProjectCompetencyData({
        Project_code: this.ProjectPlan
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
        }
      })
    },
    CheckCourseClear() {
      this.course_group = ''
      this.Project_code = ''
      this.Period_code = 0
      this.CalHourse = '0'
      this.CalCredit = '0'
    },
    DeleteDataCondi(DataCor) {
      this.ProjectQuotaDepCount -= parseInt(DataCor.count)
      this.DataCondi.map((item, index) => {
        if (item.PosCode == DataCor.PosCode) {
          this.DataCondi.splice(index, 1)
        }
      })
    },
    DeleteDepQuotaCondi(DataCor) {
      this.ProjectQuotaDepCount -= parseInt(DataCor.count)
      this.DepQuotaData.map((item, index) => {
        if (item.dep_id == DataCor.dep_id) {
          this.DepQuotaData.splice(index, 1)
        }
      })
    },
    DataCondiFunc() {
      var CheckDupe = false
      if (this.workAgeStart_Condi > this.workAgeEnd_Condi) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด คุณกรอกอายุงานไม่ถูกต้อง'
        })
      } else if (this.workAgeStart_Condi == '' || this.workAgeEnd_Condi == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด โปรดกรอกอายุงานให้ครบถ้วน'
        })
      } else {
        this.DataCondi.map((item) => {
          if (item.PosCode == this.posiCondi) {
            if (this.workAgeStart_Condi >= item.workAgeStart && this.workAgeStart_Condi <= item.workAgeEnd) {
              CheckDupe = true
            } else if (this.workAgeEnd_Condi >= item.workAgeStart && this.workAgeEnd_Condi <= item.workAgeEnd) {
              CheckDupe = true
            }
          }
        })
        if (CheckDupe) {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด อายุงานที่เลือก มีในระบบอยู่แล้ว โปรดตรวจสอบข้อมูลอายุงาน'
          })
        } else {
          this.positions.map((item) => {
            if (item.PosCode == this.posiCondi) {
              this.DataCondi.push({
                ...item,
                workAgeStart: this.workAgeStart_Condi,
                workAgeEnd: this.workAgeEnd_Condi,
              })
            }
          })
          this.posiCondi = ''
          this.levelCondi = ''
          this.workAgeStart_Condi = ''
          this.workAgeEnd_Condi = ''
          this.Course_Choose = ''
        }
      }

    },
    DeleteCourse(DataCourse) {
      this.courseCondi.map((item, index) => {
        if (item.Course_code == DataCourse.Course_code) {
          this.courseCondi.splice(index, 1)
        }
      })
    },
    CourseCondiFunc() {
      var CheckDupe = false
      this.courseCondi.map((item) => {
        if (item.Course_code == this.ChooseCourse) {
          CheckDupe = true
        }
      })
      if (CheckDupe) {
        this.$swal.fire({
          icon: 'error',
          title: 'มีข้อมูลหลักสูตรแล้ว ไม่สามารถเพิ่มข้อมูลได้อีก'
        })
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.ChooseCourse) {
            this.courseCondi.push(item)
          }
        })
        this.ChooseCourse = ''
      }
    },
    dateFunctionEvents(date) {
      const [, , day] = date.split('-')
      if ([12, 17, 28].includes(parseInt(day, 10))) return true
      if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
      return false
    },
    monthFunctionEvents(date) {
      const month = parseInt(date.split('-')[1], 10)
      if ([1, 3, 7].includes(month)) return true
      if ([2, 5, 12].includes(month)) return ['error', 'purple', 'rgba(0, 128, 0, 0.5)']
      return false
    },
    ExecInsertProject() {
      return new Promise(resolve => {
        // if (this.ProjectPlan == '') {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project', this.D_Project, {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }).then(res => {
          if (res.data.status) {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(res => {
          if (res) {
            resolve(true)
          }
        })
        // } else {
        //   this.D_Project.IsPlan = '0'
        //   axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project_code_dump, this.D_Project, {
        //     headers: {
        //       'Content-Type': 'application/json'
        //     }
        //   }).then(res => {
        //     if (res.data.status) {
        //       resolve(true)
        //     } else {
        //       resolve(false)
        //     }
        //   })
        // }
      })
    },
    insertData(status) {
      var ProjCode = this.Project_code
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project_code).then(res => {
        if (res.data) {
          this.btnDisable = false
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถใช้รหัสแผนนี้ได้ เนื่องจากมีข้อมูลอยู่แล้ว โปรดติดต่อฝ่ายเทคโนโลยีสารสนเทศ !!',
          })
        } else {
          this.D_Project.Ref_Project_code = this.Project_code_ref
          this.D_Project.Project_code = this.Project_code
          this.D_Project.Project_name = this.Project_name
          this.courseData.map((item) => {
            if (item.Course_code == this.Course_code) {
              this.D_Project.Course_code = item.Course_code
              this.D_Project.course_group = item.Course_group
            }
          })
          this.D_Project.Project_group = this.Project_group
          this.D_Project.IsProcess = this.IsProcess
          this.D_Project.Project_category = this.Project_category
          this.D_Project.Project_type = this.Project_type
          this.D_Project.Objective = this.Objective
          this.D_Project.TargetGroup = this.TargetGroup
          this.D_Project.Remarks = this.Remarks
          this.D_Project.CalCredit = this.CalCredit
          this.D_Project.CalHourse = this.CalHourse
          this.D_Project.PLACE = this.PLACE
          this.D_Project.Province_id = this.Province_id
          this.D_Project.Country_id = this.Country_id
          this.D_Project.BudgetRequest = this.BudgetRequest
          this.D_Project.Location = this.Location
          this.D_Project.WorkBy = this.WorkBy
          this.D_Project.WorkByName = this.WorkByName
          this.D_Project.WorkByPhone = this.WorkByPhone
          this.D_Project.DatePeriod = this.episode
          this.D_Project.DateStart = this.DateStart
          this.D_Project.DateEnd = this.DateEnd
          this.D_Project.Approve = this.ApproveRadio
          this.D_Project.FiscalYear = this.FiscalYear
          // this.D_Project.IsPlan = this.TypeCreateProject
          this.D_Project.IsPlan = this.isPlan
          this.D_Project.IsPlanStatus = (((this.TypeProject == '1') || (this.TypeProject == '2' && (this.IsProcess == '1' || this.IsProcess == '3'))) ? status : (this.TypeProject == '2' && this.IsProcess != '1' && status == '1') ? '2' : status)
          this.D_Project.Status_Reg = this.ChooseTypRegis
          this.D_Project.Status_Type_Reg = this.ChooseTypRegis2
          this.D_Project.DateS_Reg = this.dateRegStart
          this.D_Project.DateE_Reg = this.dateRegEnd
          this.D_Project.IsDataComplete = '1'
          if (this.ChkJoinPerson) {
            this.D_Project.Status_Count_Reg = '1'
          } else {
            this.D_Project.Status_Count_Reg = '0'
          }
          this.D_Project.Count_Reg = this.ProjectQuotaCount
          this.D_Project.Dep_Code = this.DepSelect
          this.D_Project.Create_By = this.MeData[0].perid
          this.D_Project.Create_Time = 'now()'

          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          }

          this.ExecInsertProject().then(resExec => {
            if (resExec) {
              if (this.courseCondi.length > 0) {
                var countCourseCondi = 0
                this.courseCondi.map((item) => {
                  const DataCourse = {
                    Project_code: this.Project_code,
                    Course_code: item.Course_code,
                    Credit: item.General_credit
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need', DataCourse, headerAxios).then(res => {
                    if (res.data.status) {
                      countCourseCondi++
                      if (countCourseCondi == this.courseCondi.length) {
                        this.courseCondi = []
                      }
                    }
                  })
                })
              }

              if (this.FileProject.length > 0) {
                var countFileProject = 0
                this.FileProject.map((item) => {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                    Project_code: this.Project_code,
                    File_name: item.name,
                    File_path: item.path,
                    File_type: item.type_Img,
                    Type: '0',
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()'
                  }, headerAxios).then(res => {
                    if (res.data.status) {
                      countFileProject++
                      if (countFileProject == this.FileProject.length) {
                        this.FileProject = []
                      }
                    }
                  })
                })
              }

              this.AddCompetency()

              if (status == '1' && ((this.TypeProject == '1') || (this.TypeProject == '2' && (this.IsProcess == '1' || this.IsProcess == '3')))) {
                this.initApproveMasterByType({
                  type: this.Project_category
                }).then(res => {
                  if (res) {
                    if (this.ApproveMaster.length > 0) {
                      var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.Project_category && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0' && Approveitem.project_type != '2')
                      if (SendMailApprove.length > 0) {
                        SendMailApprove.map(SendMailI => {
                          this.SendMail(SendMailI, ProjCode)
                        })
                      }
                    }
                  }
                })
              }

              this.initProjectDataForApprove({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ'
                  })

                  this.btnDisable = false

                  this.e1 = '1'

                  this.Period_code = ''
                  this.Project_code = ''
                  this.Project_name = ''
                  this.IsProcess = null
                  this.Project_category = '1'
                  this.Course_code = null
                  this.course_group = ''
                  this.Project_group = ''
                  this.Objective = ''
                  this.TargetGroup = ''
                  this.Remarks = ''
                  this.WorkBy = ''
                  this.WorkByName = ''
                  this.WorkByPhone = ''
                  this.Location = ''
                  this.DateStart = ''
                  this.DateEnd = ''
                  this.CalHourse = '0'
                  this.CalCredit = '0'
                  this.PLACE = ''
                  this.Province_id = ''
                  this.Country_id = ''
                  this.BudgetRequest = ''
                  this.ChooseTypeDep = '0'
                  this.ChooseTypRegis = '1'
                  this.ChooseTypRegis2 = '0'
                  this.dateRegStart = ''
                  this.dateRegEnd = ''
                  this.ProjectQuotaCount = ''
                  this.ProjectQuotaDepCount = 0
                  this.MessageSuc = ''
                  this.MessageError = ''
                  this.ChkJoinPerson = true
                  this.ShowAlertErr = false
                  this.ShowAlertSuc = false
                  this.DepQuotaSelect = ''
                  this.DepQuotaCount = ''
                  this.FiscalYear = this.FiscalYearData[this.FiscalYearData.length - 1].year
                  this.episode = null
                  this.files = []
                  this.ProjectPlan = null
                  this.ChooseCompetency()

                  // this.initProjectData({
                  //   perid: this.MeData[0].perid
                  // })

                  // this.initProjectPlanData({
                  //   perid: this.MeData[0].perid
                  // }).then(res => {
                  //   if (res) {
                  //     if (this.projectPalnData.length > 0) {
                  //       this.projectPalnData.map(item => {
                  //         if (item.IsPlanStatus == '1') {
                  //           this.Project_plan.push({
                  //             ...item,
                  //             full_Text:  ' โครงการประจำแผนปี ' + item.FiscalYear + ' => ' + item.Project_name
                  //           })
                  //         }
                  //       })
                  //     }
                  //   }
                  // })

                  // this.initAllPlanProjectDataForApprove().then(res => {
                  //   if (res) {
                  if (this.projectForApprove.length > 0) {
                    this.projectForApprove.map(Project => {
                      this.Project_plan.unshift({
                        ...Project,
                        full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
                      })
                      if (this.CheckAdmin) {
                        var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                        if (DepData.length > 0) {
                          this.Project_plan2.push({
                            ...Project,
                            full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
                          })
                        }
                      } else if (this.CheckSubAdmin) {
                        DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                        if (DepData.length > 0) {
                          this.Project_plan2.push({
                            ...Project,
                            full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
                          })
                        }
                      }
                    })
                    this.dialogLoading = false
                  } else {
                    this.dialogLoading = false
                  }
                  //   }
                  // })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถบันทึกข้อมูลได้',
              })

              this.btnDisable = false

              this.Project_code = ''
              this.Project_name = ''
              this.Course_code = null
              this.course_group = ''
              this.Project_group = ''
              this.Objective = ''
              this.TargetGroup = ''
              this.Remarks = ''
              this.WorkBy = ''
              this.WorkByName = ''
              this.WorkByPhone = ''
              this.Location = ''
              this.DateStart = ''
              this.DateEnd = ''
              this.CalHourse = '0'
              this.CalCredit = '0'
              this.PLACE = ''
              this.Province_id = ''
              this.Country_id = ''
              this.BudgetRequest = ''
              this.ChooseTypeDep = '0'
              this.ChooseTypRegis = '1'
              this.ChooseTypRegis2 = '0'
              this.dateRegStart = ''
              this.dateRegEnd = ''
              this.ProjectQuotaCount = ''
              this.ProjectQuotaDepCount = 0
              this.MessageSuc = ''
              this.MessageError = ''
              this.ChkJoinPerson = true
              this.ShowAlertErr = false
              this.ShowAlertSuc = false
              this.DepQuotaSelect = ''
              this.DepQuotaCount = ''
              this.FiscalYear = ''
              this.episode = null
              this.files = []
              this.ProjectPlan = null

            }
          });
        }
      })
    },
    CheckProjectCode(ProjectCode) {
      return new Promise(resolve => {
        if (this.Project == null) {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + ProjectCode).then(res => {
            if (res.data) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        } else {
          resolve(false)
        }
      })
    },
    insertProject(status) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยัน",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          // var ProjectCount = 0
          /* var date;
                date = new Date();
                date = date.getUTCFullYear() + '-' +
                    ('00' + (date.getUTCMonth()+1)).slice(-2) + '-' +
                    ('00' + date.getUTCDate()).slice(-2) + ' ' +
                    ('00' + date.getUTCHours()).slice(-2) + ':' +
                    ('00' + date.getUTCMinutes()).slice(-2) + ':' +
                    ('00' + date.getUTCSeconds()).slice(-2);*/
          this.CheckPermission().then(resPermiss => {
            if (resPermiss) {
              this.Project_code = ((parseInt(this.FiscalYear) + 543).toString().substring(2)) + '-' + this.Project_category + this.Project_type + this.isPlan + '1-0001'
              axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                queryName: 'getProjectCode',
                param: {
                  id: ((parseInt(this.FiscalYear) + 543).toString().substring(2)) + '-' + this.Project_category + this.Project_type + this.isPlan + '1'
                }
              }).then(res => {
                if (res.data) {
                  this.Project_code = res.data[0].Project_code
                }

                if (this.Project_code == '' || this.Project_name == '' || (this.Project_group == '' || this.Project_group == null) || this.PLACE == ''
                    || this.WorkBy == '' || (this.WorkByName == '' || this.WorkByName == null) || (this.WorkByPhone == '' || this.WorkByPhone == null) || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
                    || this.CalCredit == '' || this.CalHourse == '' || this.DepSelect == null || (this.TargetGroup == '' || this.TargetGroup == null) || (this.Objective == '' || this.Objective == null) || (this.isPlan == '' || this.isPlan == null) || (this.Project_category == '' || this.Project_category == null) || (this.Project_type == '' || this.Project_type == null) || (this.TypeProject == '2' && (this.IsProcess == '' || this.IsProcess == null))) {
                  /*console.log('Project_code = ' + this.Project_code)
                  console.log('Project_name = ' + this.Project_name)
                  console.log('Project_group = ' + this.Project_group)
                  console.log('PLACE = ' + this.PLACE)
                  console.log('WorkBy = ' + this.WorkBy)
                  console.log('WorkByName = ' + this.WorkByName)
                  console.log('WorkByPhone = ' + this.WorkByPhone)
                  console.log('BudgetRequest = ' + this.BudgetRequest)
                  console.log('DateEnd = ' + this.DateEnd)
                  console.log('CalCredit = ' + this.CalCredit)
                  console.log('CalHourse = ' + this.CalHourse)
                  console.log('DepSelect = ' + this.DepSelect)
                  console.log('Objective = ' + this.Objective)
                  console.log('isPlan = ' + this.isPlan)
                  console.log('Project_category = ' + this.Project_category)
                  console.log('IsProcess = ' + this.IsProcess)
                  console.log('Project_type = ' + this.Project_type)*/
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
                  })
                  this.btnDisable = false
                } else if (this.episode == null) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'ระยะเวลาที่คาดว่าจะจัด ห้ามว่าง',
                  })
                  this.btnDisable = false
                }
                /*                else if (this.Project_group == '101' || this.Project_group == '102' || this.Project_group == '103' || this.Project_group == '104') {
                                  if (this.Course_code == '0000000' || this.Course_code == '') {
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผิดพลาด',
                                      text: 'เลือกประเภทโครงการ : จัดบริหารวิชาการ,จัดพัฒนาบุคลากร เงื่อนไขหลักสูตรต้องห้ามว่าง',
                                    })
                                    this.btnDisable = false
                                  } else {
                                    this.insertData()
                                  }
                                } */
                else if (this.PLACE == '2' && this.Province_id == '') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดกรอกข้อมูลจังหวัด',
                  })
                  this.btnDisable = false
                } else if (this.PLACE == '3' && this.Country_id == '') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดกรอกข้อมูลประเทศ',
                  })
                  this.btnDisable = false
                } else if (this.selection.length == 0) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดเลือก ค่า Competency,Core Value,Strategic Objective ก่อนบันทึกข้อมูล',
                  })
                  this.btnDisable = false
                } else if (this.txtAlert.length > 0) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'โปรดตรวจสอบไฟล์ที่ต้องการอัพโหลด!!',
                  })
                  this.btnDisable = false
                } else if (this.selection.length > 0) {
                  if (this.Project_category == '1' && !this.CompetencyData[0].checkCordi && !this.CompetencyData[2].checkCordi) {
                    this.insertData(status)
                  } else if (this.Project_category != '1' && !this.CompetencyData[2].checkCordi) {
                    this.insertData(status)
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด',
                      text: this.Project_category == '1' ? 'โปรดตรวจสอบ ข้อมูล Competency และ Strategic Objective' : 'โปรดตรวจสอบ ข้อมูล Strategic Objective',
                    })
                    this.btnDisable = false
                  }
                } else {
                  this.insertData(status)
                }
              })
            } else {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    AddCompetency() {
      var headerAxiosPUT = {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      }
      if (this.selection.length > 0) {
        for (var i = 0; i <= this.selection.length - 1; i++) {
          this.CompetencyData.map(root => {
            if (root.children.length > 0) {
              root.children.map(child1 => {
                if (child1.children.length > 0) {
                  child1.children.map(child2 => {
                    if (child2.id == this.selection[i]) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                        Project_code: this.Project_code,
                        DelvNo: child2.DelvNo,
                        create_by: this.MeData[0].perid,
                        create_time: 'now()'
                      }, headerAxiosPUT)
                    }
                  })
                }
                if (child1.id == this.selection[i]) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                    Project_code: this.Project_code,
                    DelvNo: child1.DelvNo,
                    create_by: this.MeData[0].perid,
                    create_time: 'now()'
                  }, headerAxiosPUT)
                }
              })
            }
            if (root.id == this.selection[i]) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                Project_code: this.Project_code,
                DelvNo: root.DelvNo,
                create_by: this.MeData[0].perid,
                create_time: 'now()'
              }, headerAxiosPUT)
            }
          })
        }
        this.selection = []
      }
    },
    DeleteFile2(file_i) {
      this.FileProjectExpert.map((item, idx) => {
        if (item.name == file_i.name) {
          this.FileProjectExpert.splice(idx, 1)
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    getDateNow() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      if (hour.toString().length == 1) {
        hour = '0' + hour;
      }
      if (minute.toString().length == 1) {
        minute = '0' + minute;
      }
      if (second.toString().length == 1) {
        second = '0' + second;
      }
      return yyyy + '-' + mm + '-' + dd
    },
    SendMail(obj, Project_Code) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.MeData[0].perid,
        headerName: 'แจ้งเตือนการพิจารณาข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.Project_name + ' (' + Project_Code + ')',
        header: this.Project_name + ' (' + Project_Code + ')',
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการเสนอแผนตั้งงบเข้ามาใหม่ ชื่อแผน: ' + this.Project_name + ' (' + Project_Code + ')' + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + Project_Code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    ChooseCompetency() {
      this.CompetencyData = JSON.parse(JSON.stringify(this.CompetencyDataDump))
      if (this.Project_category == '1') {
        this.CompetencyData[0].checkCordi = true
        this.CompetencyData[2].checkCordi = true
      } else {
        this.CompetencyData[0].checkCordi = false
        this.CompetencyData[2].checkCordi = true
      }
      if (this.selection.length > 0) {
        for (var i = 0; i <= this.selection.length - 1; i++) {
          this.CompetencyData.map(root => {
            if (root.children.length > 0) {
              root.children.map(child1 => {
                if (child1.children.length > 0) {
                  child1.children.map(child2 => {
                    if (child2.id == this.selection[i]) {
                      if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                        root.checkCordi = false
                      }
                    }
                  })
                }
                if (child1.id == this.selection[i]) {
                  if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                    root.checkCordi = false
                  }
                }
              })
            }
            if (root.id == this.selection[i]) {
              if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                root.checkCordi = false
              } else {
                root.checkCordi = true
              }
            }
          })
        }
      }
      this.getCourseType()
    },
    init() {
      this.DateStart = (new Date().getFullYear() - 1) + '-10-01'
      this.DateEnd = new Date().getFullYear() + '-09-30'
      this.DepSelect = this.MeData[0].dep_id
      this.CompetencyData = []
      this.CompetencyDataDump = []
      this.itemsSel = []
      this.FiscalYearData = []
      this.Project_plan = []
      this.Project_plan2 = []
      this.Project_type = this.TypeProject
      this.IsProcess = null
      this.dialogLoading = true
      this.FiscalYearMenuData = []
      const today = new Date()
      this.YearSel = (today.getMonth() + 1) >= 10 ? today.getFullYear() + 1 : today.getFullYear()

      this.editorData = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'

      if ((new Date().getMonth() + 1) >= 10) {
        for (var i = new Date().getFullYear(); i <= (new Date().getFullYear() + 2); i++) {
          this.FiscalYearData.push({
            year: i,
            yearth: i + 543
          })
        }
        this.FiscalYear = new Date().getFullYear() + 1
      } else {
        for (i = new Date().getFullYear(); i <= (new Date().getFullYear() + 1); i++) {
          this.FiscalYearData.push({
            year: i,
            yearth: i + 543
          })
        }
        this.FiscalYear = new Date().getFullYear()
      }

      for (var j = 2020; j <= (new Date().getFullYear() + 3); j++) {
        this.FiscalYearMenuData.push({
          year: j,
          yearth: j + 543
        })
      }

      this.initCountryData()

      // this.initProjectPlanData({
      //   perid: this.MeData[0].perid
      // }).then(res => {
      //   if (res) {
      //     if (this.projectPalnData.length > 0) {
      //       this.projectPalnData.map(item => {
      //         if (item.IsPlanStatus == '1') {
      //           this.Project_plan.push({
      //             ...item,
      //             full_Text:  ' โครงการประจำแผนปี ' + item.FiscalYear + ' => ' + item.Project_name
      //           })
      //         }
      //       })
      //     }
      //   }
      // })

      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
        })
      }
      // this.initAllPlanProjectDataForApprove().then(res => {
      //   if (res) {
      this.selProjFiscalYear()

      /* if (this.projectForApprove.length > 0) {
        this.projectForApprove.map(Project => {
          this.Project_plan.push({
            ...Project,
            full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
          })

          if (this.CheckAdmin) {
            var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
            if (DepData.length > 0) {
              this.Project_plan2.push({
                ...Project,
                full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
              })
            }
          } else if (this.CheckSubAdmin) {
            DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
            if (DepData.length > 0) {
              this.Project_plan2.push({
                ...Project,
                full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
              })
            }
          }
        })
        this.dialogLoading = false
      } else {
        this.dialogLoading = false
      } */
      // } else {
      //   this.dialogLoading = false
      // }
      this.getCourseType()
      // }).catch(res => {
      //   if (res) {
      //     this.dialogLoading = false
      //     this.getCourseType()
      //   }
      // })

      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      this.initExpenseData({
        cost_type: this.TypeProject
      })

      if (this.committee_Posi.length == 0) {
        this.initComitteeType()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }

      if (this.levelData.length == 0) {
        this.initlevelData()
      }

      if (this.CardData.length == 0) {
        this.initCardData()
      }

      this.initCompetencyData().then(res => {
        if (res) {
          this.Competency.map(compe_i => {
            if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes,
                  DelvLevel: '0',
                  checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                  children: []
                })
              } else {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                  DelvLevel: '0',
                  checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                  children: []
                })
              }
            }
          })
          this.CompetencyData.map((data_i, idx) => {
            if (data_i.children.length == 0) {
              this.Competency.map(compe_i => {
                if (data_i.DelvNo == compe_i.DelvCover) {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '1',
                      checkCordi: false,
                      children: []
                    })
                  } else {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '1',
                      checkCordi: false,
                      children: []
                    })
                  }
                }
              })
            }
          })
          // lv2
          this.CompetencyData.map(data_i => {
            if (data_i.children.length > 0) {
              data_i.children.map((child1_i, idx) => {
                if (child1_i.children.length == 0) {
                  this.Competency.map(compe_i => {
                    if (child1_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '2',
                          checkCordi: false,
                          children: []
                        })
                      } else {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '2',
                          checkCordi: false,
                          children: []
                        })
                      }

                    }
                  })
                }
              })
            }
          })

          // item to autocomplete
          this.CompetencyData.map(itemRoot => {
            this.itemsSel.push({
              ...itemRoot
            })
            if (itemRoot.children.length > 0) {
              itemRoot.children.map(itemChild1 => {
                this.itemsSel.push({
                  ...itemChild1
                })
                if (itemChild1.children.length > 0) {
                  itemChild1.children.map(itemChild2 => {
                    this.itemsSel.push({
                      ...itemChild2
                    })
                  })
                }
              })
            }
          })

          this.CompetencyDataDump = JSON.parse(JSON.stringify(this.CompetencyData))
        }
      })
    },
    selProjFiscalYear() {
      this.dialogLoading = true;
      this.projectPlanAllData = []
      this.Project_plan = []
      this.Project_plan2 = []
      this.initProjAllPlanDataFromFiscalYear({
        FiscalYear: this.YearSel,
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
      }).then((res) => {
        if (res) {
          if (this.allPlanProj.length > 0) {
            this.projectPlanAllData = JSON.parse(JSON.stringify(this.allPlanProj))
            this.allPlanProj.map(Project => {
              this.Project_plan.push({
                ...Project,
                full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
              })

              var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
              if (DepData.length > 0) {
                this.Project_plan2.push({
                  ...Project,
                  full_Text: ('แผนปี ' + (Project.FiscalYear != null ? (parseInt(Project.FiscalYear) + 543) : ' - ') + ' => (' + Project.Project_code + ') ' + Project.Project_name).replaceAll("[^a-zA-Z]+", "")
                })
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่พบข้อมูลโครงการในปีงบประมาณที่เลือก',
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่พบข้อมูลโครงการในปีงบประมาณที่เลือก',
          })
        } 
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.dialogLoading = false
      })
    },
    clearProjectPlan() {
      this.Project_code_ref = ''
      this.selection = []
    },
  },
  mounted() {
    this.initMeData().then(async res => {
      if (res) {
        this.dialogLoading = true
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '6',
          page_sub_id: '2',
        })
        this.getSubMenuPermissData().then(res => {
          if (res) {
            if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '2' && item.PageStatus_page_id == '6' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(resAdmin => {
                if (resAdmin) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '10000') {
                      this.CheckAdmin = true
                      this.dialogLoading = false
                      this.init()
                      this.initDateForPlan().then(res => {
                        if (res) {
                          if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow() && item.year == this.FiscalYear).length > 0) {
                            this.isPlan = '1'
                            this.isPlanCordi = false
                          } else {
                            this.isPlan = '0'
                            this.isPlanCordi = true
                          }
                        }
                      }).catch(res => {
                        if (res) {
                          this.isPlan = '0'
                          this.isPlanCordi = true
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(resUser => {
                    if (resUser) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '10000') {
                          this.CheckSubAdmin = true
                          this.dialogLoading = false
                          this.init()
                          this.initDateForPlan().then(res => {
                            if (res) {
                              if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow()).length > 0) {
                                this.isPlan = '1'
                              } else {
                                this.isPlan = '0'
                              }
                            }
                          }).catch(res => {
                            if (res) {
                              this.isPlan = '0'
                              this.isPlanCordi = true
                            }
                          })
                        } else {
                          this.dialogLoading = false
                          if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.CheckSubAdmin = false
                      this.CheckAdmin = false
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.dialogLoading = false
              this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '2' && item.PageStatus_page_id == '6' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '2' && item.PageStatus_page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.dialogLoading = false
            this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '2' && item.PageStatus_page_id == '6' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '2' && item.PageStatus_page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
/*@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');*/

@font-face {
  font-family: "THSarabunNew";
  src: url('../../lib/font/THSarabunNew.ttf');
}

@font-face {
  font-family: "THSarabunNew";
  font-weight: bold;
  src: url('../../lib/font/THSarabunNew Bold.ttf');
}

.pdf-content {
  width: 100%;
  background: #fff;
}

strong {
  font-family: "THSarabunNew";
  font-weight: bold;
}

p {
  font-family: "THSarabunNew";
  font-size: 22px;
}

ul {
  font-family: "THSarabunNew";
  font-size: 22px;
}

ol {
  font-family: "THSarabunNew";
  font-size: 22px;
}

i {
  font-family: "THSarabunNew";
  font-size: 22px;
}

s {
  font-family: "THSarabunNew";
  font-size: 22px;
}


@media print {
  .no-print {
    display: none !important;
  }
}

@media screen {
  .no-screen {
    display: none !important;
  }
}

.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.ck-content {
  height: 500px;
}

.ck-editor__editable {
  min-height: 500px;
}

textarea {
  font-family: THSarabunNew;
  font-size: 24px;
}
</style>
